<template>
  <div class="shoumain">
    <el-container class="contair">
      <el-aside width="26vw" style="height:100%;overflow:hidden" > 
        <div  class="user-search " style="postion:relative">
            <el-input size="small" placeholder="请输入姓名/手机号/会员编号" v-model="selectName"  style="width:56%" >
            </el-input>
            <el-popover v-model="visible">
                  <div class="flex-xy" v-if="keyboder == true" style="height:400px;width:340px">
                    <div class="flexc-cen-x" style="width:95%">
                       <el-input size="small" placeholder="请输入内容" v-model="selectName" class="input-with-select">
                         <el-button size="small"  slot="append" class="quan" @click="toKeyd()" >全键</el-button>
                      </el-input>
                        <div class="cha flex-xy"><img src="../../assets/img/close.png" style="width:20px;height:20px" alt="" @click="quxiao()"></div>
                    </div>
                      <div style="width:95%">
                        <div v-for="(items,index) in numList" class="cs flex-spc-x">
                            <div v-for="(item,index1) in items.chlild" class="number flex-xy" @click="toNum(item)">{{item}}</div>
                        </div>
  
                        <div class="cs flex-spc-x">
                            <div class="number flex-xy" @click="toshan()">←</div>
                            <div class="number1 flex-xy" @click="toDel()">清除</div>
                            <div class="number2 flex-xy" @click="toSure()">确认</div>
                        </div>
                      </div>
                  </div>
                  <div v-if="keyboder == false" class="flex-xy" style="height:310px;width:800px">
                      <div class="flexc-cen-x" style="width:95%">
                       <el-input size="small" placeholder="请输入内容" v-model="input3" class="input-with-select">
                         <el-button size="small"  slot="append" class="quan"  @click="toKeyd()">小键</el-button>
                      </el-input>
                        <div class="cha flex-xy"><img src="../../assets/img/close.png" style="width:20px;height:20px" alt="" @click="quxiao()"></div>
                    </div>
                      <div class="qin" style="width:95%">
                        <div class="cs flex-spc-x">
                            <div class="keyd flex-xy" v-for="(items,index) in zifulist[0].chlild" @click="toNum(items)">{{items}}</div>
                        </div>
                        <div class="cs flex-spc-x">
                            <div class="keyd flex-xy" v-for="(items,index) in zifulist[1].chlild" @click="toNum(items)">{{items}}</div>
                            <div class="keyd flex-xy zi" style="background-color: #67C23A" @click="toDel()">清除</div>
                        </div>
                        <div class="cs" style="width:100%">
                          <div class="flexc-cen-x" style="width:100%">
                            <div class="keyd flex-xy zi" @click="toCHoose()">{{zifulist[4].chlild[0]}}</div>
                           <div class="keyd flex-xy"  style="margin-left:9.2px" v-for="(items,index) in zifulist[2].chlild" @click="toNum(items)">{{items}}</div>
                          </div>
                          <div class="flexc-cen-x" style="width:100%">
                            <div class="keyd flex-xy" @click="toshan()">←</div>
                             <div class="keyd flex-xy"  style="margin-left:9.2px" v-for="(items,index) in zifulist[3].chlild" @click="toNum(items)">{{items}}</div>
                            <div class="keyd flex-xy zi" style="margin-left:9.2px" @click="toKong()">空格</div>
                          </div>
                          <div class="chu flex-xy zi"   @click="toSure()">
                            确认
                          </div>
                        </div>
                      </div>
                  </div>
                  <el-button slot="reference"  size="small" class="key" @click="keyd('selectName')">  <img src="../../assets/img/keybord.png" style="width:20px;height:20px" alt=""></el-button>
            </el-popover >
            <el-button size="small"   type="primary"  @click="searchVip()">搜索</el-button>
          <el-button  size="small" style="float:right"   type="primary"  @click="handleEdit()">+新增</el-button>
        </div>
        <div class="shopMain" style="overflow:auto" ref="shop">
              <div class="vip flexc-cen-x" >
                <div class="sanjiao">
                </div>
                <img class="del cursor" src="../../assets/img/del.png" @click="toshanchu()" alt="">
                <img src="../../assets/img/touxiang.png" style="width:80px;margin-left:20px" alt="">
                <div style="width:50%">
                  <div class="name">
                    {{vipitems.Name}}<span v-if="vipitems.MembersID != 0" style="font-size:15px">({{vipitems.MemberCard}})</span> 
                  </div>
                  <div class="name" style="margin-top:10px;font-size:14px">
                    <span style="font-size:14px" v-if="vipitems.MembersID== 0">{{vipitems.LevelName}}</span> 
                    <span style="font-size:14px" v-if="vipitems.MembersID != 0">{{vipitems.LevelName}}</span> 
                    <span style="font-size:14px;margin-left:10px" v-if="vipitems.MembersID != 0">折扣:{{vipitems.preferentialvalue}}%</span> 
                  </div>
                  <div class="name" style="font-size:14px">
                     <div style="color:white;font-size:14px;" v-if="isCard == 0">余额:￥{{vipitems.czAmount}}</div>
                     <!-- 积分:<span style="font-size:14px">0</span>  -->
                  </div>
                </div>
                <div style="margin-top:10px">
                  <div class="flex-xy card cursor" @click="tochong()" v-if="vipitems.MembersID != 0  && isCard == 0"> 储蓄卡充值</div>
                </div>
              </div>
              <div :key="timer">
                <div class="css" v-for="(items,index) in payList" style="width:95%;margin-top:5px;margin-bottom:2px" >
                  <div class="flex-xy " id="shadw" style="width:96%;margin-left:2%;border-radius:5px">
                      <div style="width:95%;padding-top:10px;padding-bottom:10px">
                          <div class="flex-spc-x"> 
                              <div class="flexc-cen-x">
                                  <i class="el-icon-s-unfold" style="font-size:15px"></i>
                                  <div style="font-size:17px;margin-left:7px">{{items.name}} <span v-if="items.Specname !=''">({{items.Specname}})</span></div>
                              </div>
                          </div>
                          <div class="flex-spc-x" style="margin-top:10px;width:100%">
                              <div class="xiang" style="width:25%">￥{{items.objPrice}}</div>
                              <div class="flex-xy"  style="width:50%" >
                                <el-input-number size="mini" v-model="items.objCount" :step="1" :max="items.CommodityNum" @change="change(items,index)"></el-input-number>
                              </div>
                              <div style="font-size:16px;width:25%;text-align:right">￥{{items.objallPrice}}</div>
                          </div>
                      </div>
  
                  </div>
              </div> 
              </div>

        </div>
        <div class="bottom">
                <div class="flex-spc-x"  style="padding-top:10px">
                    <div>合计数量：{{allNum}}</div>
                    <el-button type="warning" style="font-size:15px" size="mini"  @click="todelete()">清空[Del]</el-button>
                    <!-- <div>本单积分：0</div> -->
                </div>
                <div class="flex-spc-x"  style="padding-top:10px">
                    <div>本单优惠：<span style="color:red;font-weight:700">￥{{preferential}}</span></div>
                    <div>合计金额：<span style="font-weight:700">￥{{allMoney}}</span></div>
                </div>
            <!-- <div class="bottom flex-spc-x" style="margin-top:10px;padding-top:5px">
                
                     
            </div> -->
        </div>
      </el-aside>
      <el-main class="elMain"  style="height:100%;overflow:hidden" >
          <div class="flex-spc-x user" style=" border-bottom:1px solid #e0e0e0;padding-bottom:10px">
              <div class="flexc-cen-x" style="width:100%">
                <div>
                  <el-input size="small" placeholder="请输入编号/商品名称" v-model="goodsName"  style="width:230px">
                  </el-input>
                  <el-popover v-model="visible1">
                  <div class="flex-xy" v-if="keyboder == true" style="height:400px;width:340px">
                    <div class="flexc-cen-x" style="width:95%">
                       <el-input size="small" placeholder="请输入内容" v-model="goodsName" class="input-with-select">
                         <el-button size="small"  slot="append" class="quan" @click="toKeyd()" >全键</el-button>
                      </el-input>
                        <div class="cha flex-xy"><img src="../../assets/img/close.png" style="width:20px;height:20px" alt="" @click="quxiao()"></div>
                    </div>
                      <div style="width:95%">
                        <div v-for="(items,index) in numList" class="cs flex-spc-x">
                            <div v-for="(item,index1) in items.chlild" class="number flex-xy" @click="toNum(item)">{{item}}</div>
                            <!-- <div class="number flex-xy">2</div>
                            <div class="number flex-xy">3</div> -->
                        </div>
  
                        <div class="cs flex-spc-x">
                            <div class="number flex-xy" @click="toshan()">←</div>
                            <div class="number1 flex-xy" @click="toDel()">清除</div>
                            <div class="number2 flex-xy" @click="toSure()">确认</div>
                        </div>
                      </div>
                  </div>
                  <div v-if="keyboder == false" class="flex-xy" style="height:310px;width:800px">
                      <div class="flexc-cen-x" style="width:95%">
                       <el-input size="small" placeholder="请输入内容" v-model="input3" class="input-with-select">
                         <el-button size="small"  slot="append" class="quan"  @click="toKeyd()">小键</el-button>
                      </el-input>
                        <div class="cha flex-xy"><img src="../../assets/img/close.png" style="width:20px;height:20px" alt="" @click="quxiao()"></div>
                    </div>
                      <div class="qin" style="width:95%">
                        <div class="cs flex-spc-x">
                            <div class="keyd flex-xy" v-for="(items,index) in zifulist[0].chlild" @click="toNum(items)">{{items}}</div>
                           
                        </div>
                        <div class="cs flex-spc-x">
                            <div class="keyd flex-xy" v-for="(items,index) in zifulist[1].chlild" @click="toNum(items)">{{items}}</div>
                            <div class="keyd flex-xy zi" style="background-color: #67C23A" @click="toDel()">清除</div>
                        </div>
                        <div class="cs " style="width:100%">
                          <div class="flexc-cen-x" style="width:100%">
                            <div class="keyd flex-xy zi" @click="toCHoose()">{{zifulist[4].chlild[0]}}</div>
                            
                           <div class="keyd flex-xy"  style="margin-left:9.2px" v-for="(items,index) in zifulist[2].chlild" @click="toNum(items)">{{items}}</div>
                          
                           
                          </div>
                          <div class="flexc-cen-x" style="width:100%">
                            <div class="keyd flex-xy" @click="toshan()">←</div>
                             <div class="keyd flex-xy"  style="margin-left:9.2px" v-for="(items,index) in zifulist[3].chlild" @click="toNum(items)">{{items}}</div>
                            <div class="keyd flex-xy zi" style="margin-left:9.2px" @click="toKong()">空格</div>
                          </div>
                          <div class="chu flex-xy zi"   @click="toSure()">
                            确认
                          </div>
                        </div>

                      </div>
                  </div>
                  <el-button slot="reference"  size="small" class="key" @click="keyd('goodsName')">  <img src="../../assets/img/keybord.png" style="width:20px;height:20px" alt=""></el-button>
                  </el-popover>
                  <el-button size="small"   type="primary"  @click="searchList()">搜索</el-button>
                  <!-- <el-button  size="small"   type="primary"  @click="handlePassword()">+新增</el-button> -->
                </div>
              <div class="more "  style="margin-left:20px">
                  <el-button class="fenlei" slot="reference"  @click="toquan()">           
                      <i v-if="ID == '' " class="el-icon-menu xuanze" ></i>
                      <span class="xuanze" v-if="ID == '' " style="font-size:15px">全部</span> 
                       <i v-if="ID != '' " class="el-icon-menu " ></i>
                      <span  v-if="ID != '' " style="font-size:15px">全部</span> 
                  </el-button>
              </div>
                  <div class="flexc-cen-x" style="width:40%;overflow:auto">
                    <span v-for="(items,index) in typeList" style="margin-left:10px;min-width:40px;font-size:16px">
                      <span v-if="ID == items.ID" class="xuanze cursor">{{items.CommodityTypeName}}</span>
                      <span v-else class="cursor"  @click="toChoose(items)">{{items.CommodityTypeName}}</span>
                    </span> 
                  </div>
              </div>
              <div class="qie flexc-cen-x cursor" @click="toqiehuan()" v-if="isProject == 1 && isGoods == 1">
                <img src="../../assets/img/qie.png" style="width:25px;height:25px" alt="">
                <span v-if="shop">切换{{WZXMName}}</span>
                <span v-else>切换商品</span>
              </div>
              
          </div>
          <div class="thing">
              <div class="flex-xy" style="width:100%;height:100%" v-if="tableData.length == 0">
                 <img src="../../assets/zanwu.png" alt="" style="width:100px;height:100px">
                 <div style="color:#808080">暂无数据</div>
               </div>
               <div class="box cursor"  v-for="items in tableData" @click="toadd(items)">        
                <div class="bian">{{items.CommodityNO}}</div>
                 <div class="offline___NHq4e" v-if="items.CommodityNum != 999999">库:{{items.CommodityNum}}</div>
                  <div class="main flex-xy">
                       <div class="flex-xy">
                         <div class="flexc-cen-x">
                              <img :src="items.CommodityImg" alt="" style="width:3rem;height:3rem;border-radius:20px">
                              <div class="titleMain" style="height:100%;margin-left:10px;">
                                <div  style="margin-top:5px">{{items.CommodityName}}</div>
                              
                                <div class="flex-spc-x" style="width:100%">
                                  <div class="money" style="margin-top:10px">￥{{items.procurementPrice}}/{{items.UnitName}}</div>
                                  <!-- <div>存</div> -->
                                </div>
                              </div>
                            
                         </div>
                      
                          <!-- <span class="titleMain" style="margin-left:5px">热门瑜伽</span> -->
                       </div> 
                       <!-- <div class="content" style="margin-top:5px">
                          <div>简介：12341455</div>
                           <div>简介：12341455</div>
                            <div>简介：12341455</div>
                       </div> -->
                  </div>
                    <div class="offline___NHq4e1" v-if="items.ishyzk == 0" ><img src="../../assets/bucanyu.png" alt="" style="width:20px;height:20px" srcset=""></div>
               </div>
              
          </div>
          <div class="flex-spc-x" style="margin-top:5px;">
                <div class="flexc-cen-x">

                  <el-button type="success"  @click="toshou()">应收[F6]：￥{{shouMoney}}</el-button>
                  <el-button type="success" plain @click="togua()">挂单[F7]</el-button>
                  <el-button type="success" plain @click="toqu()">取单[F8]</el-button>
                  <!-- <el-button type="success" plain @click="tokuai()">快速收银[F6]</el-button>
                  <el-button type="success" plain @click="totao()">套餐商品[F9]</el-button>
                  <el-button type="success" plain @click="tojihua()">计划项目[F10]</el-button> -->
                </div>
                <!-- <div class="flex-spc-x">
                    <img src="../../assets/img/zuo.png" style="width:30px;height:30px" alt="">
                      <div class="flex-xy" style="width:100px;font-size:18px">1/11</div>
                    <img src="../../assets/img/you.png" style="width:30px;height:30px" alt="">
                </div> -->
                   <!-- <el-button type="warning" style="font-size:15px" >清空[Del]</el-button>
                     <el-button type="success" style="font-size:15px;width:60%" >应收[F5]：￥1208080.00</el-button> -->
          </div>
      </el-main>
    </el-container>

    <!-- 编辑界面 -->
 
    <!-- </el-dialog> -->
    <!-- <el-dialog title="新增会员" :visible.sync="passShow" width="1200px" @click="closeDialog">
      <el-form label-width="120px" :model="editForm">

        <el-form-item label="项目类型" prop="deptNo">
          <el-input size="small" placeholder="请输入项目类型" v-model="Pwd" show-password auto-complete="off"></el-input>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="topass()">保存</el-button>
      </div>
    </el-dialog> -->
    <el-dialog title="挂单" :visible.sync="guadan" width="500px"  :close-on-click-modal="false">
      <el-form :model="formInline" class="" style="postion:relative">
          <el-form-item label="手牌号:" label-width="100px">
            <el-input size="small" placeholder="请输入内容" v-model="gdCode"  style="width:300px">
                  </el-input>
                  <el-popover v-model="visible2">
                    <div class="flex-xy" v-if="keyboder == true" style="height:400px;width:340px">
                      <div class="flexc-cen-x" style="width:95%">
                        <el-input size="small" placeholder="请输入内容" v-model="gdCode" class="input-with-select">
                          <el-button size="small"  slot="append" class="quan" @click="toKeyd()" >全键</el-button>
                        </el-input>
                          <div class="cha flex-xy"><img src="../../assets/img/close.png" style="width:20px;height:20px" alt="" @click="quxiao()"></div>
                      </div>
                        <div style="width:95%">
                          <div v-for="(items,index) in numList" class="cs flex-spc-x">
                              <div v-for="(item,index1) in items.chlild" class="number flex-xy" @click="toNum(item)">{{item}}</div>
                              <!-- <div class="number flex-xy">2</div>
                              <div class="number flex-xy">3</div> -->
                          </div>
    
                          <div class="cs flex-spc-x">
                              <div class="number flex-xy" @click="toshan()">←</div>
                              <div class="number1 flex-xy" @click="toDel()">清除</div>
                              <div class="number2 flex-xy" @click="toSure()">确认</div>
                          </div>
                        </div>
                    </div>
                    <div v-if="keyboder == false" class="flex-xy" style="height:310px;width:800px">
                        <div class="flexc-cen-x" style="width:95%">
                        <el-input size="small" placeholder="请输入内容" v-model="input3" class="input-with-select">
                          <el-button size="small"  slot="append" class="quan"  @click="toKeyd()">小键</el-button>
                        </el-input>
                          <div class="cha flex-xy"><img src="../../assets/img/close.png" style="width:20px;height:20px" alt="" @click="quxiao()"></div>
                      </div>
                        <div class="qin" style="width:95%">
                          <div class="cs flex-spc-x">
                              <div class="keyd flex-xy" v-for="(items,index) in zifulist[0].chlild" @click="toNum(items)">{{items}}</div>
                            
                          </div>
                          <div class="cs flex-spc-x">
                              <div class="keyd flex-xy" v-for="(items,index) in zifulist[1].chlild" @click="toNum(items)">{{items}}</div>
                              <div class="keyd flex-xy zi" style="background-color: #67C23A" @click="toDel()">清除</div>
                          </div>
                          <div class="cs " style="width:100%">
                            <div class="flexc-cen-x" style="width:100%">
                              <div class="keyd flex-xy zi" @click="toCHoose()">{{zifulist[4].chlild[0]}}</div>
                              
                            <div class="keyd flex-xy"  style="margin-left:9.2px" v-for="(items,index) in zifulist[2].chlild" @click="toNum(items)">{{items}}</div>
                            
                            
                            </div>
                            <div class="flexc-cen-x" style="width:100%">
                              <div class="keyd flex-xy" @click="toshan()">←</div>
                              <div class="keyd flex-xy"  style="margin-left:9.2px" v-for="(items,index) in zifulist[3].chlild" @click="toNum(items)">{{items}}</div>
                              <div class="keyd flex-xy zi" style="margin-left:9.2px" @click="toKong()">空格</div>
                            </div>
                            <div class="chu flex-xy zi"   @click="toSure()">
                              确认
                            </div>
                          </div>

                        </div>
                    </div>
                    <el-button slot="reference"  size="small" class="key1" @click="keyd('gdCode')">  <img src="../../assets/img/keybord.png" style="width:20px;height:20px" alt=""></el-button>
                  </el-popover >
          </el-form-item>
          <el-form-item label="备注:"  label-width="100px">
              <el-input
                style="width:300px"
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                v-model="Note">
              </el-input>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog ">取 消</el-button>
      <el-button type="primary" @click="toSuregua()">确 定</el-button>
      </span>  
    </el-dialog>
    <el-dialog title="快速消费" :visible.sync="xiaofei" width="500px"  :close-on-click-modal="false">
      <el-form :model="formInline" class="" style="postion:relative">
          <el-form-item label="消费金额:" label-width="100px">
            <el-input size="small" placeholder="请输入内容" v-model="input3"  style="width:300px">
                  </el-input>
                  <el-popover v-model="visible2">
                    <div class="flex-xy" v-if="keyboder == true" style="height:400px;width:340px">
                      <div class="flexc-cen-x" style="width:95%">
                        <el-input size="small" placeholder="请输入内容" v-model="input3" class="input-with-select">
                          <el-button size="small"  slot="append" class="quan" @click="toKeyd()" >全键</el-button>
                        </el-input>
                          <div class="cha flex-xy"><img src="../../assets/img/close.png" style="width:20px;height:20px" alt="" @click="quxiao()"></div>
                      </div>
                        <div style="width:95%">
                          <div v-for="(items,index) in numList" class="cs flex-spc-x">
                              <div v-for="(item,index1) in items.chlild" class="number flex-xy" @click="toNum(item)">{{item}}</div>
                              <!-- <div class="number flex-xy">2</div>
                              <div class="number flex-xy">3</div> -->
                          </div>
    
                          <div class="cs flex-spc-x">
                              <div class="number flex-xy" @click="toshan()">←</div>
                              <div class="number1 flex-xy" @click="toDel()">清除</div>
                              <div class="number2 flex-xy" @click="toSure()">确认</div>
                          </div>
                        </div>
                    </div>
                    <div v-if="keyboder == false" class="flex-xy" style="height:310px;width:800px">
                        <div class="flexc-cen-x" style="width:95%">
                        <el-input size="small" placeholder="请输入内容" v-model="input3" class="input-with-select">
                          <el-button size="small"  slot="append" class="quan"  @click="toKeyd()">小键</el-button>
                        </el-input>
                          <div class="cha flex-xy"><img src="../../assets/img/close.png" style="width:20px;height:20px" alt="" @click="quxiao()"></div>
                      </div>
                        <div class="qin" style="width:95%">
                          <div class="cs flex-spc-x">
                              <div class="keyd flex-xy" v-for="(items,index) in zifulist[0].chlild" @click="toNum(items)">{{items}}</div>
                            
                          </div>
                          <div class="cs flex-spc-x">
                              <div class="keyd flex-xy" v-for="(items,index) in zifulist[1].chlild" @click="toNum(items)">{{items}}</div>
                              <div class="keyd flex-xy zi" style="background-color: #67C23A" @click="toDel()">清除</div>
                          </div>
                          <div class="cs " style="width:100%">
                            <div class="flexc-cen-x" style="width:100%">
                              <div class="keyd flex-xy zi" @click="toCHoose()">{{zifulist[4].chlild[0]}}</div>
                              
                            <div class="keyd flex-xy"  style="margin-left:9.2px" v-for="(items,index) in zifulist[2].chlild" @click="toNum(items)">{{items}}</div>
                          
                            </div>
                            <div class="flexc-cen-x" style="width:100%">
                              <div class="keyd flex-xy" @click="toshan()">←</div>
                              <div class="keyd flex-xy"  style="margin-left:9.2px" v-for="(items,index) in zifulist[3].chlild" @click="toNum(items)">{{items}}</div>
                              <div class="keyd flex-xy zi" style="margin-left:9.2px" @click="toKong()">空格</div>
                            </div>
                            <div class="chu flex-xy zi"   @click="toSure()">
                              确认
                            </div>
                          </div>

                        </div>
                    </div>
                    <el-button slot="reference"  size="small" class="key1" @click="keyd()">  <img src="../../assets/img/keybord.png" style="width:20px;height:20px" alt=""></el-button>
                  </el-popover >
          </el-form-item>
          <el-form-item label="优惠活动:"  label-width="100px">
                 <el-input size="small" placeholder="请输入内容" v-model="input3"  style="width:300px">
                  </el-input>
          </el-form-item>
          <el-form-item label="获得积分"  label-width="100px">
            <el-input size="small" placeholder="请输入内容" v-model="input3"  style="width:300px">
            </el-input>
          </el-form-item>
          <el-form-item label="应付金额"  label-width="100px">
            <el-input size="small" placeholder="请输入内容" v-model="input3"  style="width:300px">
            </el-input>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="dialogVisible = false">结账</el-button>
      </span>  
    </el-dialog>
    <el-dialog :title="WZHYName+'充值'" :visible.sync="chongzhi" width="500px" :close-on-click-modal="false">
      <el-form :model="formInline" class="" style="postion:relative">
          <el-form-item label="充值金额:" label-width="100px">
            <el-input size="small" placeholder="请输入内容" v-model="money"  type="Number" style="width:300px">
                  </el-input>
                  <el-popover v-model="visible2">
                    <div class="flex-xy" v-if="keyboder == true" style="height:400px;width:340px">
                      <div class="flexc-cen-x" style="width:95%">
                        <el-input size="small" placeholder="请输入内容" v-model="money" class="input-with-select">
                          <!-- <el-button size="small"  slot="append" class="quan" @click="toKeyd()" >全键</el-button> -->
                        </el-input>
                          <div class="cha flex-xy"><img src="../../assets/img/close.png" style="width:20px;height:20px" alt="" @click="quxiao()"></div>
                      </div>
                        <div style="width:95%">
                          <div v-for="(items,index) in numList" class="cs flex-spc-x">
                              <div v-for="(item,index1) in items.chlild" class="number flex-xy" @click="toNum(item)">{{item}}</div>
                              <!-- <div class="number flex-xy">2</div>
                              <div class="number flex-xy">3</div> -->
                          </div>
    
                          <div class="cs flex-spc-x">
                              <div class="number flex-xy" @click="toshan()">←</div>
                              <div class="number1 flex-xy" @click="toDel()">清除</div>
                              <div class="number2 flex-xy" @click="toSure()">确认</div>
                          </div>
                        </div>
                    </div>
                    <div v-if="keyboder == false" class="flex-xy" style="height:310px;width:800px">
                        <div class="flexc-cen-x" style="width:95%">
                        <el-input size="small" placeholder="请输入内容" v-model="input3" class="input-with-select">
                          <el-button size="small"  slot="append" class="quan"  @click="toKeyd()">小键</el-button>
                        </el-input>
                          <div class="cha flex-xy"><img src="../../assets/img/close.png" style="width:20px;height:20px" alt="" @click="quxiao()"></div>
                      </div>
                        <div class="qin" style="width:95%">
                          <div class="cs flex-spc-x">
                              <div class="keyd flex-xy" v-for="(items,index) in zifulist[0].chlild" @click="toNum(items)">{{items}}</div>
                            
                          </div>
                          <div class="cs flex-spc-x">
                              <div class="keyd flex-xy" v-for="(items,index) in zifulist[1].chlild" @click="toNum(items)">{{items}}</div>
                              <div class="keyd flex-xy zi" style="background-color: #67C23A" @click="toDel()">清除</div>
                          </div>
                          <div class="cs " style="width:100%">
                            <div class="flexc-cen-x" style="width:100%">
                              <div class="keyd flex-xy zi" @click="toCHoose()">{{zifulist[4].chlild[0]}}</div>
                              
                            <div class="keyd flex-xy"  style="margin-left:9.2px" v-for="(items,index) in zifulist[2].chlild" @click="toNum(items)">{{items}}</div>
                            
                            </div>
                            <div class="flexc-cen-x" style="width:100%">
                              <div class="keyd flex-xy" @click="toshan()">←</div>
                              <div class="keyd flex-xy"  style="margin-left:9.2px" v-for="(items,index) in zifulist[3].chlild" @click="toNum(items)">{{items}}</div>
                              <div class="keyd flex-xy zi" style="margin-left:9.2px" @click="toKong()">空格</div>
                            </div>
                            <div class="chu flex-xy zi"   @click="toSure()">
                              确认
                            </div>
                          </div>

                        </div>
                    </div>
                    <el-button slot="reference"  size="small" class="key1" @click="keyd('money')">  <img src="../../assets/img/keybord.png" style="width:20px;height:20px" alt=""></el-button>
                  </el-popover >
          </el-form-item>
          <el-form-item label="备注:" prop="Note" label-width="100px">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="Note" style="width:300px"></el-input>
          </el-form-item>
          <!-- <el-form-item label="优惠活动:"  label-width="100px">
                 <el-input size="small" placeholder="请输入内容" v-model="input3"  style="width:300px">
                  </el-input>
          </el-form-item>
          <el-form-item label="赠送积分"  label-width="100px">
            <el-input size="small" placeholder="请输入内容" v-model="input3"  style="width:300px">
            </el-input>
          </el-form-item>
          <el-form-item label="获得积分"  label-width="100px">
            <el-input size="small" placeholder="请输入内容" v-model="input3"  style="width:300px">
            </el-input>
          </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="chongqian()">充值</el-button>
      </span>  
    </el-dialog>
    <el-dialog title="取单" :visible.sync="qudan" width="900px" :close-on-click-modal="false">
      <el-form :inline="true" :model="formInline"  >
        <el-input size="small" placeholder="请输入内容" v-model="qudanName"  style="width:800px">
        </el-input>
           <el-button size="small"   type="primary"  @click="handlePassword()">搜索</el-button>
      </el-form>
      
       <el-table :data="quList" border style="width: 100%;margin-top:12px"  size="small">
          <el-table-column  prop="OrderCode" label="订单号号" ></el-table-column>
          <el-table-column  prop="addTime" label="挂单时间"></el-table-column>
          <el-table-column  prop="MemberName" label="姓名"></el-table-column>
          <el-table-column  prop="gdCode" label="手牌号"></el-table-column>
          <el-table-column  prop="Note" label="备注"></el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          align="center"
          width="160">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" size="mini"   type="primary">取单</el-button>
            <el-button size="mini"   type="info" @click="delDan(scope.row)" >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
 <Pagination v-bind:child-msg="pageparm" @callFather="callFather1"></Pagination>
    </el-dialog>
    <el-dialog class="eldg"   title="收银结账" :visible.sync="payShow" width="1200px"  :close-on-click-modal="false">
      <div class="flex-xy" style="width:100%">
        <div class="flex-spc-x" style="width:90%">
          <div style="width:48%">
            <div class="person flexc-cen-x">
                <img src="../../assets/img/touxiang.png" style="width:80px;margin-left:20px" alt="">
                <div style="">
                  <div class="name">
                     {{vipitems.Name}}<span v-if="vipitems.MembersID != 0" style="font-size:15px">({{vipitems.MemberCard}})</span> 
                  </div>
                  <div class="name" style="margin-top:10px;font-size:14px" v-if="(preferentialType == 2 && preferentialvalue == 100)||(preferentialType == 1 && preferentialvalue == 0) ">
                    <span style="font-size:14px" v-if="vipitems.MembersID== 0">{{vipitems.LevelName}}</span> 
                    <span style="font-size:14px" v-if="vipitems.MembersID != 0">{{vipitems.LevelName}}</span> 
                    <span style="font-size:14px;margin-left:10px" v-if="vipitems.MembersID != 0">折扣:{{vipitems.preferentialvalue}}%</span> 
                  </div>
                   <div class="name" v-else style="margin-top:10px;font-size:14px">
                   <span style="font-size:14px;"  >
                      <span v-if="preferentialType  == 2 ">折扣:{{preferentialvalue}}%</span>
                      <span v-if="preferentialType  == 1 ">整单减免:{{preferentialvalue}}元</span>
                    </span>
                   </div>
                  <div class="name" v-if="personName !=''" style="margin-top:10px;font-size:14px">
                   <span style="font-size:14px;">
                      <span>提成{{WZYGName}}:{{personName}}</span>
                    </span> 
                   </div>
                </div>
                
            </div>
            <div class="flex-spc-x " style="margin-top:15px">
              <div class="pay">
                付款方式
              </div>
            </div>
            <div class="flexc-cen-x" style="margin-top:15px" >
              <div class="Choose flex-xy cursor" v-if="show1" @click="xianjin()" style="margin-left:15px">
                  <img src="../../assets/img/xianjin.png" alt="">
                  <div style="margin-top:5px">现金</div>
              </div>
              <div class="noChoose flex-xy cursor" v-if="!show1" @click="xianjin()" style="margin-left:15px">
                  <img src="../../assets/img/xianjin.png" alt="">
                  <div style="margin-top:5px">现金</div>
              </div>

              <div class="Choose flex-xy cursor" v-if="show2" style="margin-left:15px" @click="yinhangka()">
                  <img src="../../assets/img/yinlian.png" alt="">
                  <div style="margin-top:5px">银行卡</div>
              </div>
              <div class="noChoose flex-xy cursor" v-if="!show2" style="margin-left:15px" @click="yinhangka()">
                  <img src="../../assets/img/yinlian.png" alt="">
                  <div style="margin-top:5px">银行卡</div>
              </div>
              <div class="Choose flex-xy cursor" v-if="show3"  style="margin-left:15px" @click="saoma()">
                  <img src="../../assets/zfb.png" alt="" style="width:45px;height:45px;margin-top:-5px">
                  <div style="margin-top:4px">支付宝</div>
              </div>
              <div class="noChoose flex-xy cursor" v-if="!show3" style="margin-left:15px" @click="saoma()">
                  <img src="../../assets/zfb.png" alt="" style="width:45px;height:45px;margin-top:-5px">
                  <div style="margin-top:4px">支付宝</div>
              </div>
              <div class="Choose flex-xy cursor" v-if="show10"  style="margin-left:15px" @click="wechat()">
                  <img src="../../assets/wechat.png" alt="" style="width:45px;height:45px;margin-top:-5px">
                 <div style="margin-top:4px" >微信</div>
              </div>
              <div class="noChoose flex-xy cursor" v-if="!show10" style="margin-left:15px" @click="wechat()">
                  <img src="../../assets/wechat.png" alt="" style="width:45px;height:45px;margin-top:-5px">
                  <div style="margin-top:4px" >微信</div>
              </div>
            </div>
            <div class="flexc-cen-x" style="margin-top:10px"  >
              <div class="noChoose flex-xy cursor" style="margin-left:15px" v-if="!show11 && !(isCard == 1 && cardList.length == 0)"  @click="cxk()" >
                  <img src="../../assets/cxk.png" alt="" style="width:40px;height:40px;">
                  <div>储蓄卡</div>
              </div>
              <div class="Choose flex-xy cursor" style="margin-left:15px" v-if="show11 &&  !(isCard == 1 && cardList.length == 0)" @click="cxk()">
                  <img src="../../assets/cxk.png" alt="" style="width:40px;height:40px;">
                  <div>储蓄卡</div>
              </div>
              <div class="Choose flex-xy cursor" v-if="show12" @click="other()" style="margin-left:15px">
                  <img src="../../assets/other.png" alt="" style="width:40px;height:40px;">
                  <div >其他</div>
              </div>
              <div class="noChoose flex-xy cursor" v-if="!show12" @click="other()" style="margin-left:15px" >
                  <img src="../../assets/other.png" alt="" style="width:40px;height:40px;">
                  <div>其他</div>
              </div>
              <div class="noChoose flex-xy cursor" v-if="!show13"  @click="moling()" style="margin-left:15px">
                  <img src="../../assets/moling.png" alt="" style="width:40px;height:40px;">
                  <div>抹零</div>
              </div>
              <div class="Choose flex-xy cursor" v-if="show13" @click="moling()" style="margin-left:15px">
                  <img src="../../assets/moling.png" alt="" style="width:40px;height:40px;">
                  <div>抹零</div>
              </div>
            </div>
            <div class="flex-spc-x " style="margin-top:10px" >
              <div class="pay">
                更多操作
              </div>
      
            </div>
            <div class="flex-spc-x" style="margin-top:15px" >
              <div class="flex-xy moresure2 cursor"  @click="tozhengdan()">
                  <img src="../../assets/img/tool017.png" alt="">
                  <div style="margin-top:5px">整单优惠</div>
              </div>
            
              <div class="flex-xy moresure2 cursor" @click="toti()">
                  <img src="../../assets/img/tool018.png" alt="">
                  <div style="margin-top:5px">整单提成</div>
              </div>
              <div class="flex-xy moresure2 cursor"  @click="toShow6()">
                  <img src="../../assets/img/tool019.png" alt="">
                  <div style="margin-top:5px">备注</div>
              </div>
              <div class="flex-xy moresure2 cursor"  @click="toqingchu()">
                  <img src="../../assets/icon/qingchu.png" style="width:30px;height:30px" alt="">
                  <div style="margin-top:5px">清除优惠</div>
              </div>
            </div>
            <div style="margin-top:25px"> 
              <el-button type="success" style="font-size:15px;" @click="payShow = false">返回收银[Esc]</el-button>
            </div>
          </div>
          <div style="width:48%">
            <div class="shou">
                <div class="flex-spc-x" style="width:95%;margin-left:2.5%;margin-top:5px">
                  <div class="flex-xy moresure">
                    <div class="paytrue" style="margin-top:5px">应收</div>
                    <div class="monsy" style="margin-top:5px">￥{{allMoney}}</div>
                  </div>
                  <div class="flex-xy moresure">
                    <div class="paytrue" style="margin-top:5px">待收</div>
                    <div class="monsy" style="margin-top:5px">￥{{pay1}}</div>
                  </div>
                  <div class="flex-xy moresure">
               <div class="paytrue" style="margin-top:5px">优惠</div>
                    <div class="monsy" style="margin-top:5px">￥{{yPay}}</div>
                  </div>
                </div>
                <div style="margin-top:5px">
                <div style="height:160px;overflow:auto;">
                  <div class="flexc-cen-x" style="width:70%" v-if="show1">
                    <div style="width:80px;margin-left:20px">
                      现金：
                    </div>
                    <el-input size="mini" v-model="xMoney" style="width:35%"  @change="changeMoney()"  @focus="keydMoney('xMoney')" ></el-input> 元
                    <i class="el-icon-delete coBlue" style="margin-left:10px;font-size:18px" @click="xianjin()"></i>
                  </div>
                  <div  class="flexc-cen-x" style="width:70%;margin-top:10px" v-if="show2">
                    <div style="width:80px;margin-left:20px">
                      银行卡：
                    </div>
                    <el-input size="mini" v-model="yMoney" style="width:35%"  @change="changeMoney()" @focus="keydMoney('yMoney')" ></el-input> 元
                       <i class="el-icon-delete coBlue" style="margin-left:10px;font-size:18px" @click="yinhangka()"></i>
                  </div>
                  <div  class="flexc-cen-x" style="width:70%;margin-top:10px" v-if="show3">
                    <div style="width:80px;margin-left:20px">
                          支付宝：
                    </div>
                      <el-input size="mini" v-model="sMoney" style="width:35%"   @change="changeMoney()"  @focus="keydMoney('sMoney')" ></el-input> 元
                     <i class="el-icon-delete coBlue" style="margin-left:10px;font-size:18px" @click="saoma()"></i>
                  </div>
                  <div  class="flexc-cen-x" style="width:70%;margin-top:10px" v-if="show10">
                    <div style="width:80px;margin-left:20px">
                          微信：
                    </div>
                      <el-input size="mini" v-model="wMoney" style="width:35%"   @change="changeMoney()"  @focus="keydMoney('wMoney')" ></el-input> 元
                     <i class="el-icon-delete coBlue" style="margin-left:10px;font-size:18px" @click="wechat()"></i>
                  </div>
                  <div  class="flexc-cen-x" style="width:70%;margin-top:10px" v-if="show11">
                    <div style="min-width:80px;margin-left:20px">
                          <span v-if="isCard == 0">储蓄卡：</span>
                          <span v-if="isCard == 1">{{carditems.CardName}}：</span>
                    </div>
                      <el-input size="mini" v-model="cMoney" style="width:35%"  @change="changeMoney()"  @focus="keydMoney('cMoney')" ></el-input> 元
                     <i class="el-icon-delete coBlue" style="margin-left:10px;font-size:18px" @click="cxk()"></i>
                  </div>
                  <div  class="flexc-cen-x" style="width:70%;margin-top:10px" v-if="show12">
                    <div style="width:80px;margin-left:20px">
                          其他：
                    </div>
                      <el-input size="mini" v-model="oMoney" style="width:35%"   @change="changeMoney()"  @focus="keydMoney('oMoney')" ></el-input> 元
                     <i class="el-icon-delete coBlue" style="margin-left:10px;font-size:18px" @click="other()"></i>
                  </div>
                  <div  class="flexc-cen-x" style="width:70%;margin-top:10px" v-if="show13">
                    <div style="width:80px;margin-left:20px">
                          抹零：
                    </div>
                      <el-input size="mini" v-model="lMoney" style="width:35%"   @change="changeMoney()"  @focus="keydMoney('lMoney')" ></el-input> 元
                     <i class="el-icon-delete coBlue" style="margin-left:10px;font-size:18px" @click="moling()"></i>
                  </div>
                  <!-- <div  class="flexc-cen-x" style="width:100%;margin-top:10px" v-if="show11">
                    <div style="width:80px;margin-left:20px">
                          储蓄卡：
                    </div>
                      <el-input size="mini" v-model="cMoney" style="width:35%" type="Number"  @change="changeMoney()"  @focus="keydMoney('cMoney')" ></el-input> 元
                  </div> -->
                   <!-- <div  class="flexc-cen-x" style="width:100%;margin-top:10px" v-if="show4">
                    <div style="width:80px;margin-left:20px">
                          优惠：
                    </div>
                      <el-input size="mini" v-model="yPay" style="width:35%" type="Number" @focus="keydMoney('yPay')" @change="changeYpay()"></el-input> 元
                  </div> -->
                
                </div>
                   <!-- <el-form-item label="现金:" label-width="60px" v-if="show1" >
                      
                    </el-form-item>
                    <el-form-item label="银行卡:" label-width="60px" v-if="show2">
                      
                    </el-form-item>
                    <el-form-item label="扫码:" label-width="60px"  v-if="show3">
                       
                    </el-form-item> -->
            
                </div>
                <div class="shoukuan" style="font-size:14px">收款:<span style="color:red;font-size:15px;font-weight:700">￥{{shMoney}}</span></div>
            </div>
            <div class="shou1 flex-spc-x" style="margin-top:20px;">
              <div style="width:75%;height:100%">
                  <div v-for="(items,index) in qianList" class="flex-spc-x" style="width:100%;margin-top:10px">
                      <div class="num flex-xy cursor" v-for="(item,index1) in items.chlild" @click="toqian(item)">{{item}}</div>
                      
                  </div>

              </div>
              <div style="width:25%;height:100%">
                    <div class="fan flex-xy cursor" @click="tojian()"><img src="../../assets/img/jiantou.png" style="height:30px;width:40px" alt=""></div>
                    <div class="que flex-xy cursor" @click="toPay()">
                        <div>确认</div>
                        <div>支付</div>
                        <div>[F6]</div>
                    </div>
              </div>
            </div>
          </div>
        </div>
      </div>
   
    </el-dialog>
    <el-dialog title="选择规格" :visible.sync="chooseShow" width="800px":close-on-click-modal="false">
      <el-table
          ref="multipleTable"
          :data="chooseList"
          size="mini"
          tooltip-effect="dark"
          max-height="300px"
            border
          >

          <el-table-column align="center" prop="CommodityNO" label="编号"></el-table-column>
          <el-table-column align="center" prop="Specname" label="规格名称"></el-table-column> 
          <el-table-column align="center" prop="procurementPrice" label="售价"></el-table-column> 
          <el-table-column align="center" prop="CommodityNum" label="库存"></el-table-column>
          <!-- <el-table-column align="center" prop="CommodityNum" label="选择数量" width="170">
            <template slot-scope="scope">
            <el-input-number size="mini" v-model="scope.row.num"  ></el-input-number>
            </template>
          </el-table-column>  -->
          <el-table-column align="center" prop=""  label="操作">
            <template slot-scope="scope">
              <el-button   size="mini" type="primary"  @click="toclick(scope.row,scope.$index)" > 添加</el-button>
            </template>
          </el-table-column>
      </el-table>

    </el-dialog>
    <el-drawer :wrapperClosable= false :title="title" :visible.sync="editFormVisible" :direction="direction" size="30%" >
    <!-- <el-dialog :title="title" :visible.sync="editFormVisible" width="40%" @click="closeDialog"> -->
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm" style="margin-bottom:150px">
         <el-form-item label="姓名:" prop="Name">
          <el-input size="small" v-model="editForm.Name" auto-complete="off" placeholder="请输入姓名"  style="width: 215px"></el-input>
        </el-form-item>
        <el-form-item label="手机号:" prop="Phone">
          <el-input size="small" v-model="editForm.Phone" auto-complete="off" placeholder="请输入手机号" style="width: 215px"></el-input>
        </el-form-item>
        <el-form-item :label="WZHYName+'编号:'" prop="MemberCard">
          <el-input size="small" v-model="editForm.MemberCard" auto-complete="off" placeholder="请输入编号" style="width: 215px"></el-input>
        </el-form-item>

         <el-form-item :label="WZHYName+'等级:'" prop="LevelID">
            <el-select v-model="editForm.LevelID" placeholder="请选择" size="small">
                <el-option
                  v-for="item in typeList1"
                  :key="item.ID"
                  :label="item.LevelName"
                  :value="item.ID">
                </el-option>
              </el-select>
           </el-form-item>
         <el-form-item label="性别:" prop="Sex">
          <el-radio-group v-model="editForm.Sex">
             <el-radio :label="1">男</el-radio>
             <el-radio :label="2">女</el-radio>
           </el-radio-group>
          <!-- <el-input size="small" v-model="editForm.LoginName" auto-complete="off" placeholder="请输入登录账号"></el-input> -->
        </el-form-item>
        <el-form-item label="出生日期:" prop="Birthday" size="small">
          <el-date-picker
            v-model="editForm.Birthday"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="登记日期:" prop="OpenTime" size="small">
          <el-date-picker
            v-model="editForm.OpenTime"
            type="date"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="地址:" prop="Address">
          <el-input size="small" placeholder="请输入地址" v-model="editForm.Address"  auto-complete="off" style="width:90%"></el-input>
        </el-form-item>
        <el-form-item label="备注:" prop="Note">
            <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="editForm.Note" style="width:90%"></el-input>
        </el-form-item>
        <el-form-item label="业务归属人:" prop="StaffID" v-if="title == '添加'">
            <el-select v-model="StaffID" placeholder="请选择" size="small">
                <el-option
                  v-for="item in  personList"
                  :key="item.ID"
                  :label="item.Name"
                  :value="item.ID">
                </el-option>
            </el-select>
          
          <!-- <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="editForm.Note" style="width:90%"></el-input> -->
        </el-form-item>
      </el-form>

        <div class="demo-drawer__footer flex-r-x" style="width:30%">
          <el-button size="small" @click="closeDialog">取消</el-button>
          <el-button
            style="margin-right:20px"
            size="small"
            type="primary"
            @click="submitForm('editForm')"
            >保存</el-button
          >
        </div>
    </el-drawer>
    <el-dialog :title="'选择'+WZHYName" :visible.sync="vipShow" width="800px"  :close-on-click-modal="false">
      <el-table  :data="vipList" highlight-current-row v-loading="loading"  style="width: 100%;" size="mini">
          <el-table-column  prop="MemberCard" label="编号"  align="center">
          </el-table-column>
          <el-table-column  prop="Name" label="姓名" align="center" >
            <template slot-scope="scope">
              <div class="flexc-cen-x" style="margin-left:15px">
                <img :src="scope.row.HeadUrl" v-if="scope.row.HeadUrl !='' " style="width:25px;height:25px;border-radius:100%" alt="">
                <img v-if="scope.row.HeadUrl =='' " src="../../assets/img/head.png" style="width:25px;height:25px;border-radius:100%" alt="">
                <div style="margin-left:5px;font-size:15px">{{scope.row.Name}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column  prop="Phone" label="手机号"  align="center">
          </el-table-column>
          <el-table-column  prop="czAmount" label="储蓄金额(元)"  align="center">
          </el-table-column>
          <!-- <el-table-column  prop="syNumber" label="次卡次数"  align="center">
          </el-table-column> -->
          <!-- <el-table-column  prop="Address" label="地址"  align="center">
          </el-table-column> -->
          <el-table-column  prop="Note" label="备注"  align="center">
          </el-table-column>
          

        <el-table-column align="center" label="操作" width="100"  fixed="right" >
          <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="chooseVip(scope.row)">选择</el-button>
          
          </template>
        </el-table-column>
      </el-table>
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </el-dialog>
    <el-dialog title="选择优惠" :visible.sync="show4" width="400px" @click="show4 = false" :close-on-click-modal="false">
      <el-form  label-width="80px">
          <el-form-item label="优惠类型:">
            <el-radio-group v-model="preferentialType1">
              <el-radio label="1" >减免</el-radio>
              <el-radio label="2">打折</el-radio>
            </el-radio-group>
          </el-form-item>
        <el-form-item v-if="preferentialType == 1" label="减免金额:" prop="preferentialvalue">
            <el-input type="Number" size="small" v-model="preferentialvalue1" auto-complete="off" placeholder="减免金额"  style="width: 215px"></el-input> 元
        </el-form-item>
        <el-form-item v-if="preferentialType == 2" label="折扣:" prop="preferentialvalue">
            <el-input type="Number" size="small" v-model="preferentialvalue1" auto-complete="off" placeholder="请输入折扣"  style="width: 215px"></el-input> %
        </el-form-item>
          <!-- <el-form-item label="选择优惠：">
            <el-radio-group v-model="preferentialType">
              <el-radio label="减免"></el-radio>
              <el-radio label="打折"></el-radio>
            </el-radio-group>
          </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="show4 = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="sure()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="整单提成" :visible.sync="show5" width="600px" @click="show5 = false" :close-on-click-modal="false">
      <div :key="timer" class="timer">
          <div class="css flexc-cen-x" v-for="(items,index) in ListPayOrderGS" style="width:100%;margin-top:5px;margin-bottom:2px" >
                  <div class="flex-xy " id="shadw" style="width:35%;margin-left:2%;border-radius:5px">
                      <div style="width:95%;padding-top:10px;padding-bottom:10px">
                          <div class="flex-spc-x"> 
                              <div class="flexc-cen-x">
                                  <i class="el-icon-s-unfold" style="font-size:15px"></i>
                                  <div style="font-size:15px;margin-left:7px">{{items.name}} <span v-if="items.Specname !=''">({{items.Specname}})</span></div>
                              </div>
                            <el-button type="text"  @click="toChoosePerson(items)">选择{{WZYGName}}</el-button>
                          </div>
                          <div class="flex-spc-x" style="margin-top:2px;width:100%">
                              <div class="flex-xy;font-size:14px">
                                 数量： {{items.objCount}}
                              </div>
                              <div style="font-size:14px;text-align:right">总价：￥{{items.objallPrice}}</div>
                          </div>
                      </div>
                      
                  </div>
                  <div style="width:55%">
                      <div v-for="(item,index) in items.list" class="choosePerson flex-spc-x" style="margin-left:25px;width:100%">
                        <div style="width:80px">{{item.name}}</div>
                        <div class="flex-cen-x" >
                          <el-input size="mini" v-model="item.price" style="width:120px" @input="forceUpdate" placeholder="请输入内容"></el-input> 元
                        </div>
                        <div style="margin-left:12px">    
                          <el-button type="text"  icon="el-icon-delete" @click="deletePrice(index,items)"></el-button>
                        </div>
                    </div>
                  </div>
  
          </div> 
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="show5 = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" @click="Sure1()">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="'选择'+WZYGName" :visible.sync="personShow" width="500px" @click="closeDialog">
        <div class="dialogMain" style="width:100%;height:400px">
          <div class="flexc-cen-x" style="margin-bottom:10px">
              选择头衔：
            <el-select v-model="TitleID" clearable placeholder="请选择" size="mini">
                <el-option
                  v-for="item in unitList"
                  :key="item.ID"
                  :label="item.Title"
                  :value="item.ID">
                </el-option>
            </el-select>
             <el-button size="mini" style="margin-left:10px"   type="primary"  @click="getPersonList()">搜索</el-button>
          </div>
            <el-collapse>
                <el-collapse-item v-for="(items) in personList" :key="items.ID" >
                    <template slot="title">
                        <span style="margin-left:5px">{{items.Name}}</span>
                    </template>
                    <div class="cursor" v-for="item in items.listsub" :key="item.ID" style="margin-left:20px" @click="choose(item)" >
                        <div class="flexc-cen-x" style="margin-top:5px" :key="thier" > 
                            <img v-if="item.show == true" src="../../assets/icon/choose.png" alt="" style="width:18px;height:18px">
                             <img v-if="!item.show" src="../../assets/icon/nochoose.png" alt="" style="width:18px;height:18px">
                            <div style="margin-left:5px;font-size:15px">
                                {{item.Name}}
                            </div>
                        </div>   
                    </div>
                </el-collapse-item>
            </el-collapse>
          <div class=" dilag-fix flex-r-x" >
          <el-button size="small" @click="personShow = false">取消</el-button>
            <el-button
              style="margin-right:20px"
              size="small"
              type="primary"
              @click="surePerson()"
              >保存</el-button
            >
            </div>
        </div>
    </el-dialog>
    <el-dialog title="填写备注" :visible.sync="show6"  width="400px" @click="show6 = false" :close-on-click-modal="false">
      <el-form label-width="120px">

        <el-form-item label="备注：" prop="Note" style="width:90%">
           <el-input type="textarea" v-model="Note"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="show6 = false">取消</el-button>
        <el-button size="small" type="primary" :loading="loading"  @click="show6 = false">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择储蓄卡" :visible.sync="showChu" width="40%" >
      <el-form label-width="120px">
        <el-form-item label="选择">
            <el-select v-model="CardID" placeholder="请选择" size="small" >
                    <el-option
                      v-for="item in cardList"
                      :key="item.ID"
                      :label="item.CardName"
                      :value="item.ID">
                    </el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="showChu = false">取消</el-button>
        <el-button size="small" type="primary"   @click="toChooseCard()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { deptList, deptSave, deptDelete } from '../../api/userMG'
import CropperImage from "../../components/CropperImage";

import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      personShow:false,
      ID:'',
      shop:true,
      StaffID:'',
    
      Note:'',
      quanbu:false,
      goodsName:'',
      payMoney:'',
      xiaofei:false,
      chongzhi:false,
      qudanName:'',
      isCard:localStorage.getItem('isCard'),
      num:1,
      TitleID:'',
      timer:'',
      unitList:[],
      textarea:'',
      visible:false,
      payShow:false,
      visible1:false,
      visible2:false,
      CardID:'',
      passShow:false,
      guadan:false,
      preferentialType1:'',
      preferentialvalue1:'',
      selectName:'',
      qudan:false,
      kssy:false,
      pay1:'',
      tcsp:false,
      jhxm:false,
      money:0,
      list:[],
      edit:false,
      allNum:0,
      allMoney:0,
      DianList:[],
      personList:[],
      quList:[],
      listGs:[],
      isProject: localStorage.getItem('isProject'),
      isGoods:localStorage.getItem('isGoods'),
      formValidate: {
        mainImage: "",
      },
      numList:[
        {
          chlild:[
          '1','2','3'
        ]
      },
       {
          chlild:[
          '4','5','6'
        ]
      }, {
          chlild:[
          '7','8','9'
        ]
      }, {
          chlild:[
          '0','00','.'
        ]
      }
        
      ],
      zifulist:[
        {
          chlild:['1','2','3','4','5','6','7','8','9','0','00']
        },
        {
          chlild:['q','w','e','r','t','y','u','i','o','p']
        },
                {
          chlild:['a','s','d','f','g','h','j','k','l']
        },
                {
          chlild:['z','x','c','v','b','n','m','.']
        },
        {
          chlild:['大写']
        }
      ],
      zifu:[
        {
          chlild:['1','2','3','4','5','6','7','8','9','0','00']
        },
        {
          chlild:['q','w','e','r','t','y','u','i','o','p']
        },
                {
          chlild:['a','s','d','f','g','h','j','k','l']
        },
                {
          chlild:['z','x','c','v','b','n','m','.']
        },
             {
          chlild:['大写']
        }
      ],
      zifu1:[
        {
          chlild:['1','2','3','4','5','6','7','8','9','0','00']
        },
        {
          chlild:['Q','W','E','R','T','Y','U','I','O','P']
        },
                {
          chlild:['A','S','D','F','G','H','J','K','L']
        },
                {
          chlild:['Z','X','C','V','B','N','M','.']
        },
             {
          chlild:['小写']
        }
      ],
      qianList:[
        {
           chlild:['100','200','500']
        },
                {
           chlild:['1','2','3']
        },
                {
           chlild:['4','5','6']
        },
                {
           chlild:['7','8','9']
        },
                {
           chlild:['0','00','.']
        },
      ],
      input3:'',
       activeName: 'first',
      value:true,
      direction: "ltr",
      qian:'',
      money:'',
      Note:'',
      input:'',
      show1:false,
      show2:false,
      show3:false,
      show4:false,
      show5:false,
      show6:false,
      show10:false,
      show11:false,
      show12:false,
      show13:false,
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      chongShow:false,
      title: '添加',
      preferential:0,
      StaffID:'',
      preferentialType:'2',
      preferentialvalue:100,
      shouMoney:0,
      tableData:[],
      Pwd:'',
      typeList:[],
      typeList1:[],
      chooseList:[],
      ListPayOrderGS:[],
      wMoney:'',
      payList:[],
      keyboder:true,
      chooseShow:false,
      vipShow:false,
      show5:false,
      items:{},
      vipList:[],
      objtype:2,
      vipitems:{
        MembersID:0,
        MemberCard:'000',
        LevelID:0,
        Name:'散客',
        LevelName:'散客无折扣',
        czAmount:'0.00',
        preferentialType:2,
        preferentialvalue:100,
      },
      showChu:false,
      editForm: {
        LoginName:"",
        Phone:"",
        Name:"",
        pwd:"",
        money:"",
        ShopName:"",
        token: localStorage.getItem('token')
      },
      moneyName:'',
      // rules表单验证
      personList:[],
      rules: {

          Phone: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
          Name: [{ required: true, message: '请输入联系人', trigger: 'blur' }],

      },
      thier:'',
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      formPages:{
        page: 1,
        limit: 10,
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      SelectStoresID:localStorage.getItem("StoresID"),
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      LoginIDs:'',
      carditems:{},
      moneyName:'',
      WZYGName:'',
      WZHYName:'',
      WZXMName:'',
      WZPBName:'',
      xMoney:'',
      yMoney:'',
      sMoney:'',
      cMoney:'',
      wMoney:'',
      oMoney:'',
      lMoney:'',
      shMoney:0,
      ListPayOrderGS:[],
      dPay:0,
      yPay:0,
      quMain:[],
      cardList:[],
      gdCode:'',
      personName:'',
      personName1:'',
      idd:'',
      items:{},
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
        this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
    var _this = this;
        document.onkeydown = function(e) {
            let key = window.event.keyCode;
            var evt = window.event||e
          
             _this.submit(key);
          
        };
    this.getDianList()
    this.getList()
    this.getType()
    this.getUnitList()
    this.getType1()
    this.getPersonList()
      if(this.isGoods == 0){
          this.toqiehuan()
      }
      // this.getList()1
  },
 
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    toChooseCard(){
      if(this.CardID != ''){
          this.cardList.forEach(items => {
                  if(items.ID == this.CardID){
                    this.carditems = items
                    this.show11 = ! this.show11
                    this.moneyName = 'cMoney'
                    this.cMoney = ''
                    this.dPay = Number(this.shouMoney) - Number(this.yPay)  - Number(this.sMoney)   -  Number(this.yMoney) - Number(this.xMoney) -Number(this.oMoney) - Number(this.cMoney)  - Number(this.wMoney)
                    this.dPay =  this.$math.round(this.dPay,3)
                    this.shMoney =    Number(this.sMoney) +   Number(this.yMoney)  +  Number(this.xMoney)   + Number(this.oMoney)  +  Number(this.cMoney)   +  Number(this.wMoney) + Number(this.lMoney)
                    this.shMoney =  this.$math.round(this.shMoney,3)

                    this.showChu = false
              }
          });
   
      }  else {
         this.$message({
                      
                            message: "请选择储蓄卡",
                        });
      }
             
    },
    getUnitList(){
       var data = { 
          SelectStoresID:this.SelectStoresID,        
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
      }
      var that = this
      this.ajax('getListStaffTitle.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {

                that.unitList = res.data   
                     
          } 
       })
    },
  forceUpdate () { 
    this.$forceUpdate() 
  },
  deletePrice(index,items){
    console.log(index)
    console.log(items)
    items.list.splice(index,1)
    this.timer = new Date().getTime()
  },
    choose(items){
      if(items.show){
              items.show = false
          } else {
              items.show = true
          }
           this.thier =  new Date().getTime()
      },
    surePerson(){
        var LoginIDs = []
          for(var i = 0;i<this.personList.length;i++){
              var items = this.personList[i].listsub
              for(var j = 0; j<items.length;j++){
                  if(items[j].show)
                  {
                      var  price = 0
                     this.items.list.forEach(item =>{
                       if(items[j].ID == item.ID){
                          price = item.price
                       }
                   })
                      var list = {
                          name:items[j].Name,
                          ID:items[j].ID,
                          price:price,
                      }
                    LoginIDs.push(list)
                  }
                  
              }
          }

          this.items.list = LoginIDs
          this.personShow = false
         
    },
    toChoosePerson(items){
       this.personList.forEach(item => {
                       item.listsub.forEach(it=>{
                       
                            
                            it.show = false
                    
                       })
              });
          this.items = items
          console.log(items)
          if(this.items.list){
            this.items.list.forEach(items => {
                 this.personList.forEach(item => {
                       item.listsub.forEach(it=>{
                          if(it.ID == items.ID){
                           
                            it.show = true
                          } 
                       })
              });
            });
           
              
          } else {
              this.items.list = []
          }
         
          this.personShow = true
    },
    toShow6(){
      this.show6 = true
      // this.Note  = ''
    },
    changePerson(){
     this.personList.forEach(items=> {
        if(items.ID == this.idd){
            this.personName1  = items.Name
        }
     });
     
    },
    delDan(items){
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
             var data = {}
             var that = this
      data.SelectStoresID  = this.SelectStoresID 
      data.token = localStorage.getItem("token")
      data.StoresID=localStorage.getItem("StoresID")
      data.OrderID = items.ID
      this.ajax('delPayOrder.aspx',JSON.stringify(data),"POST",function(res){
                  if (res.orsuccess == "1") {
                    // that.gdCode = res.data
                        that.$message({
                            type: "success",
                            message: "删除成功",duration:2000,
                        });
                      that.getquList()
                  }

            })
        })
        .catch(() => {
          
        })
    },
    handleClick(items){
       var that = this
            var data = {}
            data.SelectStoresID  = this.SelectStoresID 
            data.token=localStorage.getItem("token")
            data.StoresID=localStorage.getItem("StoresID")
            data.OrderID = items.ID
            this.ajax('getPayOrderInfo.aspx',JSON.stringify(data),"POST",function(res){
                if (res.orsuccess == "1") {
                      that.getMain(res.data)
                        // that.quList = res.data
                        // that.qudan = true
                      }

                  })
  
    },
    getMain(data){
      this.quMain = data
      this.vipitems ={
        MembersID:data.MembersID,
        MemberCard:data.MemberCard,
        LevelID:0,
        Name:data.MemberName,
        LevelName:data.LevelName,
        czAmount:data.czAmount,
        preferentialType:2,
        preferentialvalue:data.Levelpreferentialvalue,
      }

    //     var SFPrice = this.shouMoney  - this.yPay
    // SFPrice = this.$math.round(SFPrice,3)
    this.payList = []
    var  allNum = 0
          this.preferential = data.YHPrice
          this.allMoney = data.OrderPrice
          this.shouMoney = data.OrderPrice
    data.listPayOrderObj.forEach(items=> {
      var num 
      if(items.CommodityNum !=0){
         num = items.CommodityNum
      } else {
          num = 9999999
      }
      allNum = allNum + items.objCount

        const list = {
            name:items.CommodityName,
            objtype:items.objtype,
            objID:items.objID,
            objCount:items.objCount,
            objPrice:items.objPrice,
            objallPrice:items.objallPrice,
            objPriceID:items.objPriceID,
            Attrids:items.Attrids,
            Specname:items.Specname,
            CommodityNum:num
        }
        this.payList.push(list)
    });
      this.qudan = false
      this.edit = true
    },
toPay(){
  var money = this.allMoney - this.yPay
  if(this.shMoney < money){
    this.$message({
      message: "请支付全部金额",
    });
  }  else {
     if(this.edit == false){
      this.addPay()
    } else {
      this.editPay()
    }
     
  }
},
toSuregua(){
 
    var  ListPayOrderObj = []
     if(this.payList.length == 0){
          this.$message({
          message: "请添加商品",
        })
        return
     }
 
    var isZD = ''
    if(this.yPay != 0){
        isZD = 1
    } else {
        isZD = 0
    }
    //  console.log('111')
    var SFPrice = this.allMoney  - this.preferential
    SFPrice = this.$math.round(SFPrice,3)
     this.payList.forEach(items=> {
        const list1 = {
            objtype:items.objtype,
            objID:items.objID,
            objCount:items.objCount,
            objPrice:items.objPrice,
            objallPrice:items.objallPrice,
            objPriceID:items.objPriceID,
            Attrids:items.Attrids,
            Specname:items.Specname,
        }
        ListPayOrderObj.push(list1)
    });
     var data  = {
       SelectStoresID:this.SelectStoresID,
        token: localStorage.getItem("token"),
        StoresID:localStorage.getItem("StoresID"),
        MembersID:this.vipitems.MembersID,
        LevelID:this.vipitems.LevelID,
        OrderPrice:this.allMoney,
        SFPrice:SFPrice,
        YHPrice:this.preferential,
        Note:this.Note,
        isZD:isZD,
        preferentialType:this.vipitems.preferentialType,
        preferentialvalue:this.vipitems.preferentialvalue,
        isgd:1,
        MaLingPrice:this.lMoney,
        gdCode:this.gdCode,
        iszj:1,
        sourceID:localStorage.getItem("LoginID"),
        sourceName:localStorage.getItem("Name"),
        StaffID:0,
        ListPayOrderInfo:'',
        ListPayOrderObj:JSON.stringify(ListPayOrderObj),
     }
       var that = this
      this.ajax('addPayOrder.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
            that.$message({
              type:'success',
              message: "挂单成功",duration:2000,
          });
          that.guadan = false
          that.surePay()
                // that.personList = res.data
            
          } 

      })
},
editPay(){
    var ListPayOrderInfo = []
    var  ListPayOrderObj = []
     var list = {}
    if(this.xMoney != '' && this.xMoney != 0){
         list = {
            PayType:1,
            PayAmount:this.xMoney,
            vipID:0,
           
          }
          ListPayOrderInfo.push(list)
    } 
    if(this.yMoney != '' && this.yMoney!= 0){
          list = {
            PayType:2,
            PayAmount:this.yMoney,
            vipID:0,
          }
          ListPayOrderInfo.push(list)
    } 
    if(this.sMoney != '' && this.sMoney != 0){
          list = {
            PayType:4,
            PayAmount:this.sMoney,
            vipID:0,
          }
          ListPayOrderInfo.push(list)
    } 
    // if(this.cMoney != '' && this.cMoney != 0){
    //       list = {
    //         PayType:5,
    //         PayAmount:this.cMoney,
    //         vipID:0,
    //       }
    //       ListPayOrderInfo.push(list)
    // } 
        if(this.cMoney != '' && this.cMoney != 0 && this.isCard == 0){
          list = {
            PayType:5,
            PayAmount:this.cMoney,
            vipID:-1,
          }
          ListPayOrderInfo.push(list)
    } else if( this.cMoney != '' && this.cMoney != 0 && this.isCard == 1) {
          list = {
            PayType:5,
            PayAmount:this.cMoney,
            vipID:-1,
          }
    } 
    if(this.wMoney != '' && this.wMoney != 0){
           list = {
            PayType:3,
            PayAmount:this.wMoney,
            vipID:0,
          }
          ListPayOrderInfo.push(list)
    } 
    if(this.oMoney != '' && this.oMoney != 0){
          list = {
            PayType:8,
            PayAmount:this.oMoney,
            vipID:0,
          }
          ListPayOrderInfo.push(list)
    } 
        if(this.cMoney != '' && this.cMoney != 0 && this.isCard == 0){
          list = {
            PayType:5,
            PayAmount:this.cMoney,
            vipID:-1,
          }
          ListPayOrderInfo.push(list)
    } else if( this.cMoney != '' && this.cMoney != 0 && this.isCard == 1) {
          list = {
            PayType:5,
            PayAmount:this.cMoney,
            vipID:-1,
          }
    } 
    // if(this.vipitems.czAmount<this.cMoney && this.cMoney != '' && this.cMoney != 0 ){
    //   this.$message({
    //           message: "余额不足",
    //   });
    //   return
    // }
    var isZD = ''
    if(this.yPay != 0){
        isZD = 1
    } else {
        isZD = 0
    }
    //  console.log('111')
    var SFPrice = this.shouMoney  - this.yPay
    SFPrice = this.$math.round(SFPrice,3)
     this.payList.forEach(items=> {
        const list1 = {

            objtype:items.objtype,
            objID:items.objID,
            objCount:items.objCount,
            objPrice:items.objPrice,
            objallPrice:items.objallPrice,
            objPriceID:items.objPriceID,
            Attrids:items.Attrids,
            Specname:items.Specname,

        }
        ListPayOrderObj.push(list1)
    });
    if(this.listGs.length>0){
       var liss = this.listGs
      
    } else {
     var liss = ''
    }
     var data  = {
       SelectStoresID:this.SelectStoresID,
        token: localStorage.getItem("token"),
        StoresID:localStorage.getItem("StoresID"),
        MembersID:this.vipitems.MembersID,
        LevelID:this.vipitems.LevelID,
        OrderPrice:this.shouMoney,
        SFPrice:SFPrice,
        YHPrice:this.yPay,
        Note:this.Note,
        isZD:isZD,
        OrderID:this.quMain.ID,
        MaLingPrice:this.lMoney,
        OrderCode:this.quMain.OrderCode,
        ListPayOrderGS:JSON.stringify(liss),
        preferentialType:this.preferentialType,
        preferentialvalue:this.preferentialvalue,
        isgd:0,
        gdCode:0,
        iszj:1,
        sourceID:localStorage.getItem("LoginID"),
        sourceName:localStorage.getItem("Name"),
        StaffID:this.StaffID,
        ListPayOrderInfo:JSON.stringify(ListPayOrderInfo),
        ListPayOrderObj:JSON.stringify(ListPayOrderObj),
     }
       var that = this
      this.ajax('editPayOrder.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
            that.$message({
              type:'success',
              message: "收款成功",duration:2000,
          });
          that.payShow = false
           that.edit =false
           that.surePay()
                // that.personList = res.data
            
          } 

      })
    
},

surePay(){
    this.vipitems ={
        MembersID:0,
        MemberCard:'000',
        LevelID:0,
        Name:'散客',
        LevelName:'散客无折扣',
        czAmount:'0.00',
        preferentialType:2,
        preferentialvalue:100,
      }
      this.carditems = {}
      this.CardID = ''
      this.cardList = []
       this.show1 = false
       this.show2 = false
       this.show3 = false
       this.show4 = false
       this.show5 = false
       this.show6 = false
       this.show10= false
       this.show11= false
       this.show12= false
       this.allNum = 0
       this.allMoney = 0
       this.shouMoney = 0 
       this.payList = []
       this.xMoney =''
      this.yMoney =''
      this.sMoney =''
      this.cMoney =''
      this.wMoney =''
      this.oMoney =''
      this.dPay = 0
      this.yPay = 0 
      this.preferential = 0,
      this.StaffID =''
      this.preferentialType ="2"
      this.preferentialvalue = 100
      this.edit = false
      
      this.getList()
},
addPay(){
    var ListPayOrderInfo = []
    var  ListPayOrderObj = []
     var list = {}
    if(this.xMoney != '' && this.xMoney != 0){
         list = {
            PayType:1,
            PayAmount:this.xMoney,
            vipID:0,
          }
          ListPayOrderInfo.push(list)
    } 
    if(this.yMoney != '' && this.yMoney!= 0){
          list = {
            PayType:2,
            PayAmount:this.yMoney,
            vipID:0,
          }
          ListPayOrderInfo.push(list)
    } 
    if(this.sMoney != '' && this.sMoney != 0){
          list = {
            PayType:4,
            PayAmount:this.sMoney,
            vipID:0,
          }
          ListPayOrderInfo.push(list)
    } 
    if(this.cMoney != '' && this.cMoney != 0 && this.isCard == 0){
          list = {
            PayType:5,
            PayAmount:this.cMoney,
            vipID:-1,
          }
          ListPayOrderInfo.push(list)
    } else if( this.cMoney != '' && this.cMoney != 0 && this.isCard == 1) {
          list = {
            PayType:5,
            PayAmount:this.cMoney,
            vipID:-1,
          }
    } 
    if(this.wMoney != '' && this.wMoney != 0){
           list = {
            PayType:3,
            PayAmount:this.wMoney,
            vipID:0,
          }
          ListPayOrderInfo.push(list)
    } 
    if(this.oMoney != '' && this.oMoney != 0){
          list = {
            PayType:8,
            PayAmount:this.oMoney,
            vipID:0,
          }
          ListPayOrderInfo.push(list)
    } 
    if(this.vipitems.czAmount<this.cMoney && this.cMoney != '' && this.cMoney != 0 && this.isCard == 0  ){
      this.$message({
              message: "余额不足",
      });
      return
    }
     if(this.carditems.Amount<this.cMoney && this.cMoney != '' && this.cMoney != 0 && this.isCard == 1  ){
      this.$message({
              message: "余额不足",
      });
      return
    }
    var isZD = ''
    if(this.yPay != 0){
        isZD = 1
    } else {
        isZD = 0
    }
    //  console.log('111')
    var SFPrice = this.shouMoney  - this.yPay
    SFPrice = this.$math.round(SFPrice,3)
     this.payList.forEach(items=> {
        const list1 = {
            objtype:items.objtype,
            objID:items.objID,
            objCount:items.objCount,
            objPrice:items.objPrice,
            objallPrice:items.objallPrice,
            objPriceID:items.objPriceID,
            Attrids:items.Attrids,
            Specname:items.Specname,
        }
        ListPayOrderObj.push(list1)
    });
    if(this.listGs.length>0){

      var liss = this.listGs
      
    } else {

      var liss = ''

    }
     var data  = {
       SelectStoresID:this.SelectStoresID,
        token: localStorage.getItem("token"),
        StoresID:localStorage.getItem("StoresID"),
        MembersID:this.vipitems.MembersID,
        LevelID:this.vipitems.LevelID,
        OrderPrice:this.shouMoney,
        SFPrice:SFPrice,
        YHPrice:this.yPay,
        Note:this.Note,
        isZD:isZD,
        ListPayOrderGS:liss,
        preferentialType:this.preferentialType,
        preferentialvalue:this.preferentialvalue,
        isgd:0,
        gdCode:0,
        iszj:1,
        sourceID:localStorage.getItem("LoginID"),
        sourceName:localStorage.getItem("Name"),
        StaffID:this.StaffID,
        ListPayOrderInfo:JSON.stringify(ListPayOrderInfo),
        ListPayOrderObj:JSON.stringify(ListPayOrderObj),
     }
       var that = this
      this.ajax('addPayOrder.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
            that.$message({
              type:'success',
              message: "收款成功",duration:2000,
          });
          that.payShow = false
           that.surePay()
                // that.personList = res.data
            
          } 

      })
    
},
changeYpay(){
      // if(this.yPay == '')
      // this.yPay = 0
},
keydMoney(name){
      console.log(name)
      this.moneyName = name
},
toqingchu(){
    this.yPay = this.shouMoney - this.shouMoney * 100 /100
    this.yPay = this.$math.round(this.yPay,3)
    this.dPay = this.shouMoney  - this.yPay -  this.sMoney -  this.yMoney - this.xMoney   -this.oMoney - this.cMoney  - this.wMoney
    this.dPay =  this.$math.round(this.dPay,3)
    this.pay1 = this.shouMoney
},
tozhengdan(){
  this.show4 = true
  this.preferentialType1='2'
  this.preferentialvalue1= 100 
      // this.yPay = 0
},
   toti(){
      this.idd = ''
      this.personName1 = ''
      console.log(this.payList)
      this.ListPayOrderGS = [...this.payList]
       this.show5 = true
    },
    xianjin(){
      this.show1 = !this.show1
      this.moneyName = 'xMoney'
      this.xMoney = ''
      this.dPay = Number(this.shouMoney) - Number(this.yPay)  - Number(this.sMoney)   -  Number(this.yMoney) - Number(this.xMoney) -Number(this.oMoney) - Number(this.cMoney)  - Number(this.wMoney)
      this.dPay =  this.$math.round(this.dPay,3)
      this.shMoney =    Number(this.sMoney) +   Number(this.yMoney)  +  Number(this.xMoney)   + Number(this.oMoney)  +  Number(this.cMoney)   +  Number(this.wMoney) + Number(this.lMoney)
      this.shMoney =  this.$math.round(this.shMoney,3)
    },
    yinhangka(){
      this.show2 = !this.show2
      this.moneyName = 'yMoney'
      this.yMoney = ''
      this.dPay = Number(this.shouMoney) - Number(this.yPay)  - Number(this.sMoney)   -  Number(this.yMoney) - Number(this.xMoney) -Number(this.oMoney) - Number(this.cMoney)  - Number(this.wMoney)
      this.dPay =  this.$math.round(this.dPay,3)
      this.shMoney =    Number(this.sMoney) +   Number(this.yMoney)  +  Number(this.xMoney)   + Number(this.oMoney)  +  Number(this.cMoney)   +  Number(this.wMoney) + Number(this.lMoney)
      this.shMoney =  this.$math.round(this.shMoney,3)
    },
    saoma(){
      this.show3 = !this.show3
       this.moneyName = 'sMoney'
       this.sMoney = ''
          this.dPay = Number(this.shouMoney) - Number(this.yPay)  - Number(this.sMoney)   -  Number(this.yMoney) - Number(this.xMoney) -Number(this.oMoney) - Number(this.cMoney)  - Number(this.wMoney)
      this.dPay =  this.$math.round(this.dPay,3)
      this.shMoney =    Number(this.sMoney) +   Number(this.yMoney)  +  Number(this.xMoney)   + Number(this.oMoney)  +  Number(this.cMoney)   +  Number(this.wMoney) + Number(this.lMoney)
      this.shMoney =  this.$math.round(this.shMoney,3)
    },
    wechat(){
      this.show10 = !this.show10
       this.moneyName = 'wMoney'
       this.wMoney = ''
            this.dPay = Number(this.shouMoney) - Number(this.yPay)  - Number(this.sMoney)   -  Number(this.yMoney) - Number(this.xMoney) -Number(this.oMoney) - Number(this.cMoney)  - Number(this.wMoney)
      this.dPay =  this.$math.round(this.dPay,3)
      this.shMoney =    Number(this.sMoney) +   Number(this.yMoney)  +  Number(this.xMoney)   + Number(this.oMoney)  +  Number(this.cMoney)   +  Number(this.wMoney) + Number(this.lMoney)
      this.shMoney =  this.$math.round(this.shMoney,3)
    },
    cxk(){

      if(this.isCard ==1){
        if(this.show11 == false){
            this.showChu = true
        } else {
          this.show11 = !this.show11
          this.moneyName = 'cMoney'
          this.cMoney = ''
          this.dPay = Number(this.shouMoney) - Number(this.yPay)  - Number(this.sMoney)   -  Number(this.yMoney) - Number(this.xMoney) -Number(this.oMoney) - Number(this.cMoney)  - Number(this.wMoney)
          this.dPay =  this.$math.round(this.dPay,3)
          this.shMoney =    Number(this.sMoney) +   Number(this.yMoney)  +  Number(this.xMoney)   + Number(this.oMoney)  +  Number(this.cMoney)   +  Number(this.wMoney) + Number(this.lMoney)
          this.shMoney =  this.$math.round(this.shMoney,3)
          this.carditems = {}
          this.CardID = ''
        }
         
      } else {
          this.show11 = !this.show11
          this.moneyName = 'cMoney'
          this.cMoney = ''
          this.dPay = Number(this.shouMoney) - Number(this.yPay)  - Number(this.sMoney)   -  Number(this.yMoney) - Number(this.xMoney) -Number(this.oMoney) - Number(this.cMoney)  - Number(this.wMoney)
          this.dPay =  this.$math.round(this.dPay,3)
          this.shMoney =    Number(this.sMoney) +   Number(this.yMoney)  +  Number(this.xMoney)   + Number(this.oMoney)  +  Number(this.cMoney)   +  Number(this.wMoney) + Number(this.lMoney)
          this.shMoney =  this.$math.round(this.shMoney,3)
      }
    
    
 
    },
    other(){
      this.show12 = !this.show12
      this.moneyName = 'oMoney'
      this.oMoney = ''
      this.dPay = Number(this.shouMoney) - Number(this.yPay)  - Number(this.sMoney)   -  Number(this.yMoney) - Number(this.xMoney) -Number(this.oMoney) - Number(this.cMoney)  - Number(this.wMoney)
      this.dPay =  this.$math.round(this.dPay,3)
      this.shMoney =    Number(this.sMoney) +   Number(this.yMoney)  +  Number(this.xMoney)   + Number(this.oMoney)  +  Number(this.cMoney)   +  Number(this.wMoney) + Number(this.lMoney)
      this.shMoney =  this.$math.round(this.shMoney,3)
    },
    moling(){
      this.show13 = !this.show13
      this.moneyName = 'lMoney'
      this.lMoney = ''
      this.dPay = Number(this.shouMoney) - Number(this.yPay)  - Number(this.sMoney)   -  Number(this.yMoney) - Number(this.xMoney) -Number(this.oMoney) - Number(this.cMoney)  - Number(this.wMoney)
      this.dPay =  this.$math.round(this.dPay,3)
      this.shMoney =    Number(this.sMoney) +   Number(this.yMoney)  +  Number(this.xMoney)   + Number(this.oMoney)  +  Number(this.cMoney)   +  Number(this.wMoney) + Number(this.lMoney)
      this.shMoney =  this.$math.round(this.shMoney,3)
    },
    searchList(){
      this.getList()
    },
    chongqian(){
      var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          LoginID:localStorage.getItem('LoginID'),
          MembersID:this.vipitems.MembersID,
          czAmount:this.money,
          Note:this.Note,

      }
        var that = this
        this.ajax('editMembersczAmount.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.vipitems.czAmount =  Number(that.vipitems.czAmount)  +  Number(that.money)
                // that.tableData = res.data
     
               that.$message({
                            type: "success",
                            message: "充值成功",duration:2000,
                  });
            that.chongzhi = false
            // that.getList()
          } 

      })
    },
    chooseVip(vip){
      this.vipitems = vip
      this.vipitems.MembersID = vip.ID
      this.vipitems.preferentialType = '2'
      this.vipShow = false
         var num = 0
        var money = 0
        var preferential = 0
          this.payList.forEach(items => {
            num =  num + items.objCount 
            money = money + Number(items.objallPrice) 
            if(items.ishyzk == 1){
                preferential = preferential +(items.objallPrice - items.objallPrice * Number(this.vipitems.preferentialvalue) /100)
            } 
          })
          // console.log('111',this.payList)
          this.allNum = num
          this.allMoney = money
          // this.preferential = this.allMoney - this.allMoney * Number(this.vipitems.preferentialvalue) /100
          this.preferential = this.$math.round(preferential,3)
          this.shouMoney = this.allMoney 
          this.shouMoney= this.$math.round(this.shouMoney,3)
        // var num = 0
        // var money = 0
        //   this.payList.forEach(items => {
        //     num =  num + items.objCount 
        //     money = money + Number(items.objallPrice) 
        //   })
        //   this.allNum = num
        //   this.allMoney = money
        //   this.preferential = this.allMoney - this.allMoney * Number(this.vipitems.preferentialvalue) /100
        //   this.preferential = this.$math.round(this.preferential,3)
        //   this.shouMoney = this.allMoney 
        //   this.shouMoney= this.$math.round(this.shouMoney,3)
          if(this.isCard == 1){
              this.getVipCard()
          }
        
    },
    getVipCard(){
       var data  = {
       SelectStoresID:this.SelectStoresID,
        token: localStorage.getItem("token"),
        StoresID:localStorage.getItem("StoresID"),
        MembersID:this.vipitems.MembersID,

     }
       var that = this
      this.ajax('getListMembersvipCX.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
              that.cardList = res.data
                // that.personList = res.data
            
          } 

      })
    
    },
    searchVip(){
        var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
          selectName:this.selectName,
      }
      var that = this
      this.ajax('getListMemberssy.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.vipShow = true
                that.vipList = res.data
                //  loading.close();
          } 

      })
    },
    todelete(){
      this.payList = []
      this.allMoney = 0
      this.allNum = 0 
      this.preferential = 0
      this.shouMoney = 0
    },
    change(items,index){
      this.timer = new Date().getTime()

        if(items.objCount != 0){
          items.objallPrice = items.objCount * items.objPrice
         
       
        } else {
            var list =  [...this.payList]
            list.splice(index,1)
            this.payList = [...list]
        }
       var num = 0
        var money = 0
        var preferential = 0
          this.payList.forEach(items => {
            num =  num + items.objCount 
            money = money + Number(items.objallPrice) 
            if(items.ishyzk == 1){
                preferential = preferential +(items.objallPrice - items.objallPrice * Number(this.vipitems.preferentialvalue) /100)
            } 
          })
          // console.log('111',this.payList)
          this.allNum = num
          this.allMoney = money
          // this.preferential = this.allMoney - this.allMoney * Number(this.vipitems.preferentialvalue) /100
          this.preferential = this.$math.round(preferential,3)
          this.shouMoney = this.allMoney 
          this.shouMoney= this.$math.round(this.shouMoney,3)
        // var num = 0
        // var money = 0
        // this.payList.forEach(items => {
        //   num =  num + items.objCount 
        //   money = money + Number(items.objallPrice) 
        // })
        // this.allNum = num
        // this.allMoney = money
        // this.preferential = this.allMoney - this.allMoney * Number(this.vipitems.preferentialvalue) /100
        // this.preferential = this.$math.round(this.preferential,3)
        // this.shouMoney = this.allMoney 
        // this.shouMoney= this.$math.round(this.shouMoney,3)
    },
    toclick(items,index){
        var list = {
            name:this.items.CommodityName,
            objtype:this.objtype,
            objID:this.items.ID,
            objCount:1,
            ishyzk:this.items.ishyzk,
            objPrice:items.procurementPrice,
            objallPrice:items.procurementPrice,
            objPriceID:items.ID,
            Attrids:items.Attrids,
            Specname:items.Specname,
            CommodityNum:Number(items.CommodityNum)
          }
          var cd = 0
          this.payList.forEach(items => {
              if(items.objID == list.objID  && items.objPriceID == list.objPriceID ){
                if(items.objCount == list.CommodityNum || items.objCount > list.CommodityNum){
                    this.$message({
                      message: '超出库存,无法添加'
                    })
                     cd = 1
                } else {
                items.objCount = items.objCount + 1
                items.objallPrice = items.objCount * items.objPrice
                   cd = 1
                }
              }
          });
          if(cd == 0 &&  list.CommodityNum > 0){
                this.payList.push(list)
                this.chooseList.splice(index,1)
          }  
          if(cd == 0 && (list.CommodityNum <0||list.CommodityNum == 0 ) ){
             this.$message({
                      message: '库存不足！'
                    })
          }
        
        var num = 0
        var money = 0
        var preferential = 0
          this.payList.forEach(items => {
            num =  num + items.objCount 
            money = money + Number(items.objallPrice) 
            if(items.ishyzk == 1){
                preferential = preferential +(items.objallPrice - items.objallPrice * Number(this.vipitems.preferentialvalue) /100)
            } 
          })
          // console.log('111',this.payList)
          this.allNum = num
          this.allMoney = money
          // this.preferential = this.allMoney - this.allMoney * Number(this.vipitems.preferentialvalue) /100
          this.preferential = this.$math.round(preferential,3)
          this.shouMoney = this.allMoney 
          this.shouMoney= this.$math.round(this.shouMoney,3)
      // console.log(row)
      this.$nextTick(function() {
        var container = this.$refs.shop
        container.scrollTo({        //滚动动画
          top: container.scrollHeight,
          behavior: 'smooth'
        })
      })
    },
    toadd(items){  
      if(items.isSoldout == 0 || !items.isSoldout){
          if(items.listCommodityPrice.length == 0){
          var list = {
            name:items.CommodityName,
            objtype:this.objtype,
            objID:items.ID,
            objCount:1,
            objPrice:items.procurementPrice,
            objallPrice:items.procurementPrice,
            objPriceID:0,
            Attrids:'',
            Specname:'',
            ishyzk:items.ishyzk,
            CommodityNum:Number(items.CommodityNum)
          }
          var cd = 0
          this.payList.forEach(items => {
            console.log(items.objPrice)     
              if(items.objID == list.objID && items.objPriceID == list.objPriceID ){
                if(items.objCount == list.CommodityNum){
                    this.$message({
                      message: '超出库存,无法添加'
                    })
                     cd = 1
                } else {
                items.objCount = items.objCount + 1
                items.objallPrice = items.objCount * items.objPrice
                   cd = 1
                }
                
              }
          });
          if(cd == 0 &&  list.CommodityNum > 0){
                this.payList.push(list)
                // this.chooseList.splice(index,1)
          }  
          if(cd == 0 && (list.CommodityNum <0||list.CommodityNum == 0 ) ){
             this.$message({
                      message: '库存不足！'
                    })
          }
          
        

          }  else {
          this.items = items
          console.log(this.items)
          this.chooseList = items.listCommodityPrice
          this.chooseShow = true
        }
           var num = 0
        var money = 0
        var preferential = 0
          this.payList.forEach(items => {
            num =  num + items.objCount 
            money = money + Number(items.objallPrice) 
            if(items.ishyzk == 1){
                preferential = preferential +(items.objallPrice - items.objallPrice * Number(this.vipitems.preferentialvalue) /100)
            } 
          })
          // console.log('111',this.payList)
          this.allNum = num
          this.allMoney = money
          // this.preferential = this.allMoney - this.allMoney * Number(this.vipitems.preferentialvalue) /100
          this.preferential = this.$math.round(preferential,3)
          this.shouMoney = this.allMoney 
          this.shouMoney= this.$math.round(this.shouMoney,3)
          // var num = 0
          // var money = 0
          // this.payList.forEach(items => {
          //   num =  num + items.objCount 
          //   money = money + Number(items.objallPrice) 
          // })
          // this.allNum = num
          // this.allMoney = money
          // this.preferential = this.allMoney - this.allMoney * Number(this.vipitems.preferentialvalue) /100
          // this.preferential = this.$math.round(this.preferential,3)
          // this.shouMoney = this.allMoney 
          // this.shouMoney= this.$math.round(this.shouMoney,3)
      } else {
         this.$message({
          message: "商品已售罄",
        });
      }
       this.$nextTick(function() {
        var container = this.$refs.shop
        container.scrollTo({        //滚动动画
          top: container.scrollHeight,
          behavior: 'smooth'
        })
      })


    },
    toquan(){
      this.ID = ''
      this.getList()
    },
    toChoose(items){
        this.ID = items.ID
         this.getList()
    },
    getDianList(){
       var data = { 
          SelectStoresID:localStorage.getItem("StoresID"),
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID")
      }
        var that = this
       this.ajax('getListStores.aspx',JSON.stringify(data),"POST",function(res){

           if (res.orsuccess == "1") {
               that.DianList =res.data
               that.SelectStoresID = res.data[0].ID
               
            }

      })
},
    getList1(){

    //  this.tableLoading = true
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:100,
          StaffTypeID:''
      }
     
      
        var that = this
      this.ajax('getListStaff.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {

                that.personList = res.data

          } 

      })
  
  
    },
    getList(){
     if(this.shop == true){
         var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:100,
          selectName:this.goodsName,
          CommodityType:this.ID,
      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListCommodity.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
                 loading.close();
          } 

      })
     } else {
        var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:100,
          selectName:this.goodsName,
          ProjectTypeID:this.ID,
      }
       const loading = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      
        var that = this
      this.ajax('getListProject.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.tableData = res.data
                that.tableData.forEach(items => {
                items.CommodityNO = items.ProjectNO
                items.CommodityImg = items.HeadUrl
                items.CommodityName = items.ProjectName
                items.procurementPrice = items.Amount
                items.UnitName = '项'
                items.CommodityNum = 999999
                items.listCommodityPrice = []
                items.CommodityNum = 999999
                  // items.
                });
               
                 loading.close();
          } 

      })
     }
    },
    getType(){
        if(this.shop){
           var data = { 
        SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:1,
          psize:100,
      }

      var that = this
      this.ajax('getListCommodityType.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
            
                that.typeList = res.data

          } 
        })
      } else {
            var data = { 
                SelectStoresID:this.SelectStoresID,
                token: localStorage.getItem("token"),
                StoresID:localStorage.getItem("StoresID"),
                pages:1,
                psize:100,
            }

      var that = this
      this.ajax('getListProjectType.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                // that.tableLoading = false
                that.typeList = res.data
    
                that.typeList.forEach(items => {
                      items.CommodityTypeName = items.ProjectTypeName
                });
          } 

      })
        }
      
    },
    getType1(){
       var data = { SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
            pages:1,
            psize:100,
      }
      var that = this
      this.ajax('getListMembersLevel.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
  
                that.typeList1 = res.data
                //  loading.close();
          } 
       })
    
    },
    getPersonList(){ 
      var data = { 
            SelectStoresID:this.SelectStoresID,
            token: localStorage.getItem("token"),
            StoresID:localStorage.getItem("StoresID"),
            Title:this.TitleID
         }
        var that = this
       this.ajax('getlistStaffgl.aspx',JSON.stringify(data),"POST",function(res){
           if (res.orsuccess == "1") {
               that.personList = res.data                 
            }
      })
  
    },
    toshanchu(){
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.surePay()
            // this.jie1(row)
        })
        .catch(() => {
          
        })
      
    },
    toqiehuan(){
      console.log(this.shop)
      this.shop = !this.shop
      if(this.shop){
        this.objtype = 2
      } else {
        this.objtype = 1
      }
      this.getList()
      this.getType()
    },
    toqu(){
      this.getquList()
    },
    getquList(){
      var that = this
            var data = {}
            data.SelectStoresID  = this.SelectStoresID 
            data.token=localStorage.getItem("token")
            data.StoresID=localStorage.getItem("StoresID")
            data.pages = 1
            data.psize = 10
            data.selectNmae = this.qudanName
            this.ajax('getListPayOrdergdCode.aspx',JSON.stringify(data),"POST",function(res){
                if (res.orsuccess == "1") {
                        that.quList = res.data
                        that.quList.forEach(items => {
                          items.addTime = items.addTime.replace(/\//g, '-')
                        });
                        that.qudan = true
                    }
                })
  
    },
    tokuai(){
        this.xiaofei = true
    },
    totao(){

    },
    tojihua(){

    },
    togua(){
      this.getGDCode()
      this.guadan = true
    },
    getGDCode(){
      var that = this
      var data = {}
      data.SelectStoresID  = this.SelectStoresID 
      data.token = localStorage.getItem("token")
      data.StoresID=localStorage.getItem("StoresID")
      this.ajax('getGDCode.aspx',JSON.stringify(data),"POST",function(res){
                  if (res.orsuccess == "1") {
                    that.gdCode = res.data
                          //   that.$message({
                          //   type: "success",
                          //   message: "新建成功",
                          // });
                        that.editFormVisible = false
                        // that.getList()
                      }

                  })
    },
    toshou(){
      if(this.payList.length != 0){

        this.preferentialType =  this.vipitems.preferentialType
        this.preferentialvalue = this.vipitems.preferentialvalue
        this.yPay = this.preferential
        this.dPay = this.allMoney  -this.yPay 
        this.dPay =  this.$math.round(this.dPay,3)
        this.pay1 = this.dPay
        this.payShow = true
        this.personName = ''
        this.StaffID = ''
        this.Note = ''
        this.show1 = false
        this.show2 = false
        this.show3 = false
        this.show10 = false
        this.show11 = false
        this.show12 = false
        this.show13 = false
        this.shMoney = 0
      } else {
         this.$message({
          message: "请选择商品",
        });
      }
        
    },
    Sure1(){
      var listGs = []
      this.ListPayOrderGS.forEach(items => {

        if(items.list){
          items.list.forEach(item => {
      
                    var it = {
                            objtype:items.objtype,
                            objID:items.objID,
                            StaffID:item.ID,
                            PriceTC:item.price,
                            objPriceID:items.objPriceID
                          }
           
                          
                          listGs.push(it)
                  });
          }
      });
      this.show5 = false
      this.listGs = listGs
    },
    sure(){
        this.preferentialType =  this.preferentialType1
        this.preferentialType = this.preferentialType1
      if(this.preferentialType == 1){
        this.yPay =this.preferentialvalue1 
        this.dPay = this.shouMoney  - this.yPay -  this.sMoney -  this.yMoney - this.xMoney   -this.oMoney - this.cMoney  - this.wMoney
        this.dPay =  this.$math.round(this.dPay,3)
      }
      if(this.preferentialType == 2){
        this.yPay = this.shouMoney - this.shouMoney * Number(this.preferentialvalue1) /100
        this.yPay = this.$math.round(this.yPay,3)
        this.dPay = this.shouMoney  - this.yPay -  this.sMoney -  this.yMoney - this.xMoney   -this.oMoney - this.cMoney  - this.wMoney
        this.dPay =  this.$math.round(this.dPay,3)
        // this.yPay = this.preferentialvalue
      }
      this.pay1 = this.$math.round(this.shouMoney - this.yPay,3)
      this.show4 = false
    },
    tochong(){
      this.chongzhi = true
    },
     submit(key) {
        // alert(key)
      if(key == '27'){

            // esc
        }
      if(key == '46'){
        this.todelete()
            // del
        }
    
      if(key == '113'){
            // f2
        }
      if(key == '114'){
            // f3
        }
      if(key == '116'){
         
            // f5
        }
         if(key == '117'){

          //  this.tokuai()
           if(this.payShow == true){
              this.toPay()
          } else {
              this.toshou()
          }
         
            // f6
        }
      if(key == '118'){
        this.togua()
            // f7
        }
      if(key == '119'){
        this.toqu()
            // f8
        }
      if(key == '120'){
         this.totao()
            // f9
        }
      if(key == '121'){
        this.tojihua()
            // f10
        }
              
    },
    toMain(items){
      console.log(items)
    },
    tojian(){
      if(this.moneyName == 'sMoney' && this.show3){
        this.sMoney =  this.sMoney.substr(0,this.sMoney.length-1)
      }
      if(this.moneyName == 'yMoney' && this.show2){
         this.yMoney = this.yMoney.substr(0,this.yMoney.length-1)
      }
      if(this.moneyName == 'xMoney' && this.show1){
        this.xMoney =  this.xMoney.substr(0,this.xMoney.length-1)
      }
      if(this.moneyName == 'yPay' && this.show4){
        this.yPay =  this.yPay.substr(0,this.yPay.length-1)
      }
      if(this.moneyName == 'wMoney' && this.show10){
        this.wMoney =  this.wMoney.substr(0,this.wMoney.length-1)
      }
      if(this.moneyName == 'cMoney' && this.show11){
        this.cMoney =  this.cMoney.substr(0,this.cMoney.length-1)
      }
      if(this.moneyName == 'oMoney' && this.show12){
        this.oMoney =  this.oMoney.substr(0,this.oMoney.length-1)
      }
      if(this.moneyName == 'lMoney' && this.show13){
        this.lMoney =  this.lMoney.substr(0,this.lMoney.length-1)
      }
      if(Number(this.cMoney) > Number(this.vipitems.czAmount) ){
          this.cMoney = this.vipitems.czAmount
          console.log(this.cMoney)
          console.log(this.vipitems.czAmount)
      }
          this.dPay = Number(this.shouMoney) - Number(this.yPay)  - Number(this.sMoney)   -  Number(this.yMoney) - Number(this.xMoney) -Number(this.oMoney) - Number(this.cMoney)  - Number(this.wMoney)
      this.dPay =  this.$math.round(this.dPay,3)
      this.shMoney =    Number(this.sMoney) +   Number(this.yMoney)  +  Number(this.xMoney)   + Number(this.oMoney)  +  Number(this.cMoney)   +  Number(this.wMoney) + Number(this.lMoney)
      this.shMoney =  this.$math.round(this.shMoney,3)
    },
    changeMoney(){
      if( (Number(this.cMoney) > Number(this.vipitems.czAmount) && this.isCard == 0)|| (Number(this.cMoney) > Number(this.carditems.Amount) && this.isCard == 1) ){
          this.cMoney = this.vipitems.czAmount
          console.log(this.cMoney)
          console.log(this.vipitems.czAmount)
      }

      this.dPay = Number(this.shouMoney) - Number(this.yPay)  - Number(this.sMoney)   -  Number(this.yMoney) - Number(this.xMoney) -Number(this.oMoney) - Number(this.cMoney)  - Number(this.wMoney)
      this.dPay =  this.$math.round(this.dPay,3)
      this.shMoney =    Number(this.sMoney) +   Number(this.yMoney)  +  Number(this.xMoney)   + Number(this.oMoney)  +  Number(this.cMoney)   +  Number(this.wMoney) + Number(this.lMoney)
      this.shMoney =  this.$math.round(this.shMoney,3)
    },
    toqian(item){
      if(this.moneyName == 'xMoney' && this.show1){
              this.xMoney =  this.xMoney + item
      
      }
      if(this.moneyName == 'yMoney' && this.show2){
              this.yMoney=  this.yMoney + item
  
      }
      if(this.moneyName == 'sMoney'  && this.show3){
            this.sMoney =  this.sMoney + item

      }

      if(this.moneyName == 'yPay' && this.show4){
        this.yPay =  this.yPay  + item
      }

    if(this.moneyName == 'wMoney' && this.show10){
      this.wMoney=  this.wMoney + item
      }
      if(this.moneyName == 'cMoney' && this.show11){
       this.cMoney=  this.cMoney + item
      }
      if(this.moneyName == 'oMoney' && this.show12){
      this.oMoney=  this.oMoney + item
       }
      if(this.moneyName == 'lMoney' && this.show13){
        this.lMoney =   this.lMoney +  item
      }
      if(Number(this.cMoney) > Number(this.vipitems.czAmount) ){
          this.cMoney = this.vipitems.czAmount
          console.log(this.cMoney)
          console.log(this.vipitems.czAmount)
      }
      this.dPay = Number(this.shouMoney) - Number(this.yPay)  - Number(this.sMoney)   -  Number(this.yMoney) - Number(this.xMoney) -Number(this.oMoney) - Number(this.cMoney)  - Number(this.wMoney)
      this.dPay =  this.$math.round(this.dPay,3)
      this.shMoney =    Number(this.sMoney) +   Number(this.yMoney)  +  Number(this.xMoney)   + Number(this.oMoney)  +  Number(this.cMoney)   +  Number(this.wMoney) + Number(this.lMoney)
      this.shMoney =  this.$math.round(this.shMoney,3)
    },
    toMore(){
         this.editFormVisible = true
    },
    toKong(){
       if(this.searchName == 'selectName'){
          this.selectName = this.selectName + ' '
      }

       if(this.searchName == 'goodsName'){
          this.goodsName =  this.goodsName +' '
      }
      if(this.searchName == 'gdCode'){
         this.gdCode =  this.gdCode +' '
      }
      
    },
    toCHoose(){
      if(this.zifulist[4].chlild[0] == '大写'){
        this.zifulist = this.zifu1
      } else {
         this.zifulist  = this.zifu
      }
    },
    toshan(){
      if(this.searchName == 'selectName'){
          this.selectName = this.selectName.substr(0,this.selectName.length-1)
      }
      if(this.searchName == 'money'){
            this.money = this.money.substr(0,this.money.length-1)
      }
       if(this.searchName == 'goodsName'){
            this.goodsName = this.goodsName.substr(0,this.goodsName.length-1)
      }
        if(this.searchName == 'gdCode'){
            this.gdCode = this.gdCode.substr(0,this.gdCode.length-1)
      }
      
    },
    toDel(){
          if(this.searchName == 'selectName'){
            this.selectName = ''
          }
          if(this.searchName == 'money'){
            this.money = ''
      }
        if(this.searchName == 'goodsName'){
            this.goodsName = ''
      }
      if(this.searchName == 'gdCode'){
           this.gdCode = ''
      }

},
    toNum(item){
      if(this.searchName == 'selectName'){
        this.selectName = this.selectName + item
      }
      if(this.searchName == 'money'){
            this.money = this.money+ item
      }
      if(this.searchName == 'goodsName'){
            this.goodsName = this.goodsName+ item
      }
      if(this.searchName == 'gdCode'){
            this.gdCode = this.gdCode+ item
      }
    
    },
    keyd(name){
      this.searchName =  name
       this.keyboder = true
       
    },
    toKeyd(){
        console.log(this.keyboder)
        this.keyboder = !this.keyboder
    
    },
      
     toSure(){
       this.visible = false
       this.visible1 = false
       this.guadan = false
     },
    quxiao(){
      this.visible = false,
      this.input3 = ''
      this.money = ''
      this.selectName = ''
      this.visible1 = false
      this.visible2 = false
      this.visible3 = false
    },

    handlePassword(row){
      // this.editForm.ManageLoginID = row.ID
      // this.Pwd = ''
      // this.passShow = true
      this.formPages.page = 1
      this.formPages.limit = 10
      this.getquList()

    },
    handleChong(row){
      this.editForm.ManageLoginID = row.ID
      this.editForm.money = row.money
       this.chongShow = true
      this.money = ''
    },
    // 获取公司列表

    // 分页插件事件
    callFather1(parm){
      this.formPages.page = parm.currentPage
      this.formPages.limit = parm.pageSize
      this.getquList()
    },
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.searchVip()
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    //显示编辑界面

    handleEdit: function(row) {
      
          var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth() + 1;
          var day = date.getDate();
          if (month < 10) {
          month = '0' + month;
          }
          if (day < 10) {
          day = '0' + day;
          }
          var nowDate = year + '-' + month + '-' + day;
          this.editForm.OpenTime = nowDate
           this.title = '添加'
           this.getVIpCard()

    },
    getVIpCard(){
      var data = { 
          SelectStoresID:this.SelectStoresID,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          // ProjectTypeID:this.active
          // StaffTypeID:this.active
      }

      
        var that = this
      this.ajax('getMemberCode.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                // console.log(res.data)
               that.editForm={
                LoginName:"",
                Phone:"",
                Name:"",
                pwd:"",
                money:"",
                ShopName:"",
                HeadUrl:'',
                Sex:1,
                Address:'',
                Birthday:'2000-10-10',
                OpenTime:'',
                LevelID:'',
                StaffID:'',
                MemberCard:res.data

            }
              
                 that.editFormVisible = true
       
          } 

      })
    },

    add(){
        var that = this
            var data = {}
            data.SelectStoresID  = this.SelectStoresID 
            data.token=localStorage.getItem("token")
            data.StoresID=localStorage.getItem("StoresID")
            this.ajax('addMembers.aspx',JSON.stringify(data),"POST",function(res){
                  if (res.orsuccess == "1") {
                            that.$message({
                            type: "success",
                            message: "新建成功",duration:2000,
                          });
                        that.editFormVisible = false
                        // that.getList()
                      }

                  })
  
    },
    submitForm(editData) {

      this.$refs[editData].validate(valid => {
        if (valid) {
            if(this.title == '添加'){
                this.add()
            }else {
                this.edit()
            }
        } else {
          return false
        }
      })
    },








   
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
            this.delete(row)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.passShow = false
      this.chongShow = false
      this.vipShow =false
      this.chongzhi = false
      this.editFormVisible = false
    }
  }
}
</script>
<style>
.dialogMain{
    overflow: auto;
}
.dilag-fix{
    position:absolute;
    right: 0;
    bottom: 0;
    margin-bottom: 10px;

}
.timer{
    max-height: 50vh;
    overflow: auto;
  }
.contair{
  padding: 0 !important;
  margin-top:-20px;
  height: 90vh;
  overflow: hidden !important;
}
.qie{
  width: 108px !important;
  color:#67C23A;
  font-weight: 500;
  font-size: 16px;


}
.shoukuan{
  position: absolute;
  right: 0;
  bottom:0;
  margin-right: 5px;
  
  /* padding-bottom: 20px; */

}

.xuanze{
  color:#409EFF
}
.fenlei{
  border:none;
  padding:5px
}
.card{
  background-color: #b336fc;
  color:white;
  font-size: 13px;
  padding: 6px;
  border-radius: 5px;
}
/* .el-main{
  overflow:hidden !important
} */
.el-dialog{
    margin-top:6vh !important
}
</style>
<style scoped>
.shopMain{
  height:calc(90vh - 140px);
}
.thing{
  margin-top:10px;
  width:100%;
  height:calc(90vh - 232px);
  overflow:auto;
  padding-bottom: 88px;
  border-bottom:2px solid #e0e0e0;
}
.lay1:hover{
  background-color: rgb(216, 216, 216);
}
.lay1{
  padding-right: 10px;
  padding-left:10px;
  width: 200px;
  height: 40px;
  font-size:14px;

}
.del{
   position: absolute;
   width: 28px;
   height: 28px;
   right: 0;
   top: 0;

}
  .vip{
  position:relative;
  width: 99%;
  height:100px;
  border-radius: 5px;
  background-color: rgb(24, 185, 118);
  }
.sanjiao{
  position: absolute;
  width: 0;
  right:0;
  margin-top:-50px;
  height: 0;
  opacity: 0.7;
  border-top: 50px solid rgb(255, 255, 255);
  border-left: 50px solid transparent;
}
  .que{
  width: 90%;
  margin-top:10px;
  margin-left:10px;
  color: white;
  height: 61%;
  background-color: #67C23A !important;
  border-radius: 5px;
   font-size: 25px;
  }
.fan{
    font-size: 30px;
    font-weight:bolder;
  width: 90%;
  margin-top:10px;
  margin-left:10px;
  height: 38%;
   border:1px solid #858585;
  border-radius: 5px;
}
.num{
  width: 30%;
   border:1px solid #858585;
  border-radius: 5px;
  height: 42px;
  font-size: 20px;
  font-weight: 700;
}
.monsy{
  color:#E6A23C;
  font-weight: 900;
  font-size: 16px;
}
.paytrue{
  font-size: 17px;
  font-weight: 900;
}
  .shou{
    height: 250px;
    border:1px solid rgb(24, 185, 118);
    border-radius: 5px;
    position: relative;
  }

  .shou1{
    height: 250px;
    /* border:1px solid rgb(24, 185, 118); */
    border-radius: 5px;
  }
 .moresure{
    width: 30%;
    height:70px;
  border:1px solid #ebebeb;
  border-radius: 5px;
 }
.moresure2{
  width: 20%;
  height:70px;
  border:1px solid #ebebeb;
  border-radius: 5px;
 }
.moresure1{
    width: 30%;
    height:70px;
  border:1px solid #409EFF;
  border-radius: 5px;
 }
.noChoose{
  width:70px;
  height:70px;
  border:1px solid #ebebeb;
  border-radius: 5px;
}
.Choose{
  width:70px;
  height:70px;
  border:1px solid #409EFF;
  border-radius: 5px;
}
.pay{
  font-size: 16px;
   font-weight: 600;
   color: rgb(24, 185, 118);;
}
.name{
  font-size: 18px;
  color: white;
  font-weight: 500;
}


.more{
  color: #409EFF;
}

  .lay{
    overflow:hidden
  }
  .elMain{
    margin-left:10px;
    border-left:10px  solid #eeeeee
  }
.qin{
  position: relative;
}
.zi{
  font-size:18px !important;
  font-weight: 400 !important;
}
.chu{
  position:absolute;
  margin-left: 92%;
  margin-top: -116px;
  height: 116px;
  width: 8%;
  background-color:#E6A23C;
  color:white;

   border-radius: 2px;
}
.quan{
  background-color: #67C23A !important;
  color: white !important;
  padding: 9.5px 15px !important;

}

.cha{
  margin-left: -2px;
  border: 1px solid #d8d8d8;
  border-radius: 2px;
  width: 35px;
  height: 30px;
  font-size: 25px;
  color:#67C23A;
  font-weight: 3000 !important;
}
.keyd{
  margin-top: 10px;
  width: 8%;
  color:white;
  background-color:#409EFF;
  border-radius: 4px;
  height: 53px;
  font-size: 20px;
   font-weight: 800;
}
.number{
  width: 30%;
  background-color:#409EFF;
  height: 54px;
  margin-top: 20px;
  border-radius: 4px;
  color:white;
  font-size:25px;
  font-weight: 800;
}
.number1{
  width: 30%;
  background-color:#67C23A;
  height: 54px;
  margin-top: 20px;
  border-radius: 4px;
  color:white;
  font-size:20px;
  font-weight: 400;
}
.number2{
  width: 30%;
  background-color:#E6A23C;
    height: 54px;
  margin-top: 20px;
  border-radius: 4px;
  color:white;
  font-size:20px;
  font-weight: 400;
}
.key{
  padding: 4px 4px;
  position: absolute;
  z-index: 99;
  margin-top: 1px;
  margin-left: -35px;
  border:none;
  background-color: none !important;
  /* margin-top: 100px; */
  /* margin: left 100px; */
}
.key1{
  padding: 4px 4px;
  position: absolute;
  z-index: 99;
  margin-top: 6px;
  margin-left: -35px;
  border:none;
  background-color: none !important;
  /* margin-top: 100px; */
  /* margin: left 100px; */
}

.person{
  width: 100%;
  height:130px;
  border-radius: 5px;
  background-color: rgb(24, 185, 118);
}
.bottom{
  margin-top: 5px;
  border-top:2px solid #e0e0e0;
  font-size: 15px;
}
.css{
  border-bottom: 1px solid #e9e9e9;
}
.main{
  position: absolute;
  height: 80px;
}
.content{
    font-size: 12px;
  color: #999;
  line-height: 20px;
}
.money{
  color:rgb(243, 138, 0)
}
.titleMain{
    font-size: 14px;
    color: #191919;
    line-height: 22px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.bian{
    position: absolute;
    top: 3px;
    font-size: 13px;
    left: 5px;
    font-weight: 600;
    color: #F56C6C;
}
.offline___NHq4e {
    position: absolute;
    top: -1px;
    right: -1px;
    padding: 0.5px 4px 0.5px 4px;
    /* width: 64px; */
    /* height: 22px; */
    background: rgba(255, 101, 247, 0.04);
    border-radius: 0 8px 0 8px;
    border: 1px solid rgba(187, 14, 255, 0.2);
    font-size: 12px;
    text-align: center;
    line-height: 20px;
    color: #b336fc;
}
.offline___NHq4e1 {
    position: absolute;
      bottom: 0;
    right: -1px;
    padding: 0.5px 4px 0.5px 4px;

    border-radius: 0 8px 0 8px;
 
    font-size: 12px;
    text-align: center;
    line-height: 20px;
} 
.box{
  position: relative;
    width: calc((100% - 150px)/5);
    padding: 20px;
    box-sizing: border-box;
    display: inline-block;
    margin-right: 16px;
    margin-bottom: 16px;
    border-radius: 8px;
    border: 1px solid #ececec;
    box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
    height: 110px;
}
@media screen and ( max-width: 1600px ) {
  .box{
    cursor: pointer;
    width: calc((100% - 100px)/4);
  }
}
.box:hover{
  box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
}
/* .shadow:hover {
    border:1px solid #808080;border-radius:2px
} */
.shadow {
    border:1px solid #ffffff;border-radius:2px
}

.xiang{
    /* padding: 1px 4px  1px 4px;
    background-color: #f7f7f7;
    border:1px solid #bbbbbb;
    border-radius: 3px; */
    font-size: 14px;
    color:#bbbbbb;
}
  
/* .el-switch__core::after{
 height: 12px !important;
 width :12px !important;
} */
   
.title{
    margin-top: 10px;
    height: 30px;
    font-size: 13px;
    font-weight: bolder;
    border-radius: 3px;
    border-left: 5px solid #334157;

}
.user{
 position: relative;
}
.user-search {
  margin-top: 20px;
  padding-bottom: 10px;
  border-bottom:1px solid #e0e0e0;
 position: relative;
  }
.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/machine/MachineConfig.vue